var map = {
	"./2025/1000Icon.png": 210,
	"./2025/1400Icon.png": 211,
	"./2025/1600Icon.png": 212,
	"./2025/900Icon.png": 213,
	"./2025/arrow.gif": 14,
	"./2025/arrow_next.png": 214,
	"./2025/arrow_next2.png": 82,
	"./2025/black-arrow-gif.gif": 1376,
	"./2025/black-arrow.png": 1377,
	"./2025/blue-arrow.gif": 1378,
	"./2025/multiplayerIcon.png": 215,
	"./2025/nextTopic_bg.png": 1379,
	"./2025/topic1000/a_video.png": 1380,
	"./2025/topic1000/a_video_mobile.png": 1381,
	"./2025/topic1000/background-1.png": 1382,
	"./2025/topic1000/background-2.png": 1383,
	"./2025/topic1000/background-3.png": 1384,
	"./2025/topic1000/background-4-mobile.png": 1385,
	"./2025/topic1000/background-4.png": 1386,
	"./2025/topic1000/background-5-1.png": 1387,
	"./2025/topic1000/background-6.png": 216,
	"./2025/topic1000/computer-mobile.png": 217,
	"./2025/topic1000/computer.png": 218,
	"./2025/topic1000/ele_example_1_1.png": 219,
	"./2025/topic1000/ele_example_2_1.png": 220,
	"./2025/topic1000/ele_example_2_2.png": 221,
	"./2025/topic1000/ele_example_3_1.png": 222,
	"./2025/topic1000/ele_example_3_2.png": 223,
	"./2025/topic1000/ele_example_4_1.png": 224,
	"./2025/topic1000/ele_example_4_2.png": 225,
	"./2025/topic1000/ele_example_4_3.png": 226,
	"./2025/topic1000/example_img_1_1.png": 227,
	"./2025/topic1000/example_img_1_2.png": 228,
	"./2025/topic1000/example_img_1_3.png": 229,
	"./2025/topic1000/example_img_1_4.png": 230,
	"./2025/topic1000/example_img_1_5.png": 231,
	"./2025/topic1000/example_img_1_6.png": 232,
	"./2025/topic1000/example_img_1_6_1.png": 233,
	"./2025/topic1000/example_img_1_7.png": 1388,
	"./2025/topic1000/example_img_1_7_1.png": 234,
	"./2025/topic1000/person-back.png": 1389,
	"./2025/topic1000/person-cover.png": 1390,
	"./2025/topic1000/person.png": 1391,
	"./2025/topic1000/quiz_bg.png": 1392,
	"./2025/topic1000/quiz_bg_mobile.png": 1393,
	"./2025/topic1000/section2_4_1.png": 1394,
	"./2025/topic1000/section2_4_3.png": 1395,
	"./2025/topic1000/section2_4_3_m.png": 1396,
	"./2025/topic1000/section2_back.png": 1397,
	"./2025/topic1000/section3_1_0.png": 235,
	"./2025/topic1000/section3_1_1.png": 1398,
	"./2025/topic1000/section3_1_2.png": 236,
	"./2025/topic1000/section3_2_1.png": 237,
	"./2025/topic1000/section3_2_1_cn.png": 238,
	"./2025/topic1000/section3_2_1_sc.png": 239,
	"./2025/topic1000/section3_3_1.png": 240,
	"./2025/topic1000/section3_3_2.png": 241,
	"./2025/topic1000/section3_3_2_m.png": 242,
	"./2025/topic1000/section3_4_1.png": 1399,
	"./2025/topic1000/section3_back.png": 1400,
	"./2025/topic1000/section4/arrow-circle.png": 1401,
	"./2025/topic1000/section4/arrow.png": 1402,
	"./2025/topic1000/section4/background-1.png": 1403,
	"./2025/topic1000/section4/background-2.png": 1404,
	"./2025/topic1000/section4/background-3-mobile.png": 1405,
	"./2025/topic1000/section4/background-3.png": 1406,
	"./2025/topic1000/section4/background-4.png": 1407,
	"./2025/topic1000/section4/background-5.png": 1408,
	"./2025/topic1000/section4/background-6.png": 1409,
	"./2025/topic1000/section4/black-arrow.png": 1410,
	"./2025/topic1000/section4/computer-icon.png": 1411,
	"./2025/topic1000/section4/dialog-box-1-en.png": 1412,
	"./2025/topic1000/section4/dialog-box-1-mobile.png": 1413,
	"./2025/topic1000/section4/dialog-box-1.png": 1414,
	"./2025/topic1000/section4/dialog-box-2-en.png": 1415,
	"./2025/topic1000/section4/dialog-box-2-mobile.png": 1416,
	"./2025/topic1000/section4/dialog-box-2.png": 1417,
	"./2025/topic1000/section4/dialog-box-3-mobile.png": 1418,
	"./2025/topic1000/section4/dialog-box-3.png": 1419,
	"./2025/topic1000/section4/dialog-box-4-mobile.png": 1420,
	"./2025/topic1000/section4/dialog-box-4.png": 1421,
	"./2025/topic1000/section5/background-1.png": 1422,
	"./2025/topic1000/section5/background-2.png": 1423,
	"./2025/topic1000/section5/background-3.png": 1424,
	"./2025/topic1000/section5/blue-box.png": 1425,
	"./2025/topic1000/section5/bottom-decoration.png": 1426,
	"./2025/topic1000/section5/flower-computer.png": 1427,
	"./2025/topic1000/section5/orange-box.png": 1428,
	"./2025/topic1000/section5/persons.png": 1429,
	"./2025/topic1000/spot1.png": 1430,
	"./2025/topic1000/spot2.png": 1431,
	"./2025/topic1000/spot3.png": 1432,
	"./2025/topic1000/warning.png": 1433,
	"./2025/topic1400/elePerson_2_1.png": 243,
	"./2025/topic1400/elePerson_2_2.png": 244,
	"./2025/topic1400/file_bg.png": 1434,
	"./2025/topic1400/file_bg_m.png": 1435,
	"./2025/topic1400/file_bg_m2.png": 1436,
	"./2025/topic1400/file_left_person.png": 245,
	"./2025/topic1400/file_right_img.png": 246,
	"./2025/topic1400/left_icon.svg": 1437,
	"./2025/topic1400/line_left_bg.png": 1438,
	"./2025/topic1400/line_right_bg.png": 1439,
	"./2025/topic1400/news_bg.png": 1440,
	"./2025/topic1400/practice_img.png": 247,
	"./2025/topic1400/practice_left_bg.png": 248,
	"./2025/topic1400/quiz_bg.png": 1441,
	"./2025/topic1400/quiz_bg_mobile.png": 1442,
	"./2025/topic1400/right_icon.png": 249,
	"./2025/topic1400/risk_person.png": 250,
	"./2025/topic1400/section3_3_1.png": 251,
	"./2025/topic1400/section3_3_2.png": 252,
	"./2025/topic1400/section3_3_2_m.png": 253,
	"./2025/topic1400/shared_file_bg.png": 1443,
	"./2025/topic1400/shared_file_bg1.png": 1444,
	"./2025/topic1400/shared_file_bg2.png": 1445,
	"./2025/topic1400/shared_left_bottom.png": 121,
	"./2025/topic1400/top_bg.png": 1446,
	"./2025/topic1400/top_ele1.png": 1447,
	"./2025/topic1400/top_flowers.png": 254,
	"./2025/topic1400/top_icon.png": 1448,
	"./2025/topic1400/top_person.png": 255,
	"./2025/topic1400/top_tips.png": 1449,
	"./2025/topic1400/wrong_icon.png": 256,
	"./2025/topic1600/background-1.png": 1450,
	"./2025/topic1600/background-2.png": 1451,
	"./2025/topic1600/background-3.png": 1452,
	"./2025/topic1600/background-4.png": 1453,
	"./2025/topic1600/background-5-1.png": 1454,
	"./2025/topic1600/background-5.png": 1455,
	"./2025/topic1600/background-6-mobile.png": 1456,
	"./2025/topic1600/background-6.png": 1457,
	"./2025/topic1600/computer.png": 1458,
	"./2025/topic1600/connect-vpn-1.png": 1459,
	"./2025/topic1600/connect-vpn-2.png": 1460,
	"./2025/topic1600/example-1.png": 257,
	"./2025/topic1600/flower-1.png": 1461,
	"./2025/topic1600/flower.png": 1462,
	"./2025/topic1600/header-icon.png": 1463,
	"./2025/topic1600/info-lock.png": 1464,
	"./2025/topic1600/person-1.png": 1465,
	"./2025/topic1600/person-2.png": 1466,
	"./2025/topic1600/person.png": 1467,
	"./2025/topic1600/quiz_bg.png": 1468,
	"./2025/topic1600/quiz_bg_mobile.png": 1469,
	"./2025/topic1600/right-icon.png": 1470,
	"./2025/topic1600/section2_7.png": 258,
	"./2025/topic1600/section2_7_1.png": 259,
	"./2025/topic1600/section2_7_mobile.png": 260,
	"./2025/topic1600/section2_8.png": 261,
	"./2025/topic1600/section2_81.png": 262,
	"./2025/topic1600/section2_9.png": 263,
	"./2025/topic1600/silkRibbon-1.png": 1471,
	"./2025/topic1600/silkRibbon-2.png": 1472,
	"./2025/topic1600/transfer-arrow.png": 1473,
	"./2025/topic1600/vpn-background-1-mobile.png": 1474,
	"./2025/topic1600/vpn-background-1.png": 1475,
	"./2025/topic1600/vpn-background-2-mobile.png": 1476,
	"./2025/topic1600/vpn-background-2.png": 1477,
	"./2025/topic1600/wave.png": 1478,
	"./2025/topic1600/wrong-icon.png": 1479,
	"./2025/topic900/CenterCircle.png": 264,
	"./2025/topic900/arrow_orange_left.png": 1480,
	"./2025/topic900/arrow_r.png": 1481,
	"./2025/topic900/back_1_3.png": 1482,
	"./2025/topic900/back_1_3_m.png": 265,
	"./2025/topic900/back_lines1.png": 1483,
	"./2025/topic900/back_pad1.png": 1484,
	"./2025/topic900/back_piece1.5.png": 1485,
	"./2025/topic900/bottom_left.png": 1486,
	"./2025/topic900/code_icon1.png": 266,
	"./2025/topic900/code_icon2.png": 267,
	"./2025/topic900/code_icon3.png": 268,
	"./2025/topic900/code_icon4.png": 269,
	"./2025/topic900/code_icon5.png": 270,
	"./2025/topic900/code_icon6.png": 271,
	"./2025/topic900/correct_icon.png": 122,
	"./2025/topic900/eleImg_pwd_2_1.png": 1487,
	"./2025/topic900/eleImg_pwd_2_2.png": 1488,
	"./2025/topic900/eleImg_pwd_2_3.png": 1489,
	"./2025/topic900/eleImg_pwd_2_4.png": 1490,
	"./2025/topic900/elePerson1-1.png": 272,
	"./2025/topic900/elePerson_2_1.png": 123,
	"./2025/topic900/elePerson_2_2.png": 124,
	"./2025/topic900/elePerson_2_3.png": 273,
	"./2025/topic900/elePerson_2_4.png": 274,
	"./2025/topic900/ele_Preson_3_2.png": 1491,
	"./2025/topic900/ele_Preson_3_2_m.png": 1492,
	"./2025/topic900/ele_icon_lock.png": 1493,
	"./2025/topic900/en_img.png": 275,
	"./2025/topic900/error_icon.png": 125,
	"./2025/topic900/flower.png": 1494,
	"./2025/topic900/icon1-1.png": 1495,
	"./2025/topic900/icon_clock1.png": 1496,
	"./2025/topic900/icon_correct.png": 1497,
	"./2025/topic900/icon_error.png": 1498,
	"./2025/topic900/icon_flower1.png": 1499,
	"./2025/topic900/icon_text1.png": 1500,
	"./2025/topic900/icon_text2.png": 1501,
	"./2025/topic900/line_bg_2.png": 1502,
	"./2025/topic900/pwd_type1.png": 109,
	"./2025/topic900/pwd_type2.png": 110,
	"./2025/topic900/pwd_type_3_1.png": 165,
	"./2025/topic900/pwd_type_3_3.png": 166,
	"./2025/topic900/pwd_type_3_4.png": 135,
	"./2025/topic900/pwd_type_3_4_1.png": 276,
	"./2025/topic900/quiz_bg.png": 1503,
	"./2025/topic900/quiz_bg_mobile.png": 1504,
	"./2025/topic900/step/step1.png": 777,
	"./2025/topic900/step/step2.png": 778,
	"./2025/topic900/step/step3.png": 779,
	"./2025/topic900/step/step4.png": 780,
	"./2025/topic900/tab/item_bg1.png": 1505,
	"./2025/topic900/tab/item_bg2.png": 1506,
	"./2025/topic900/tab/item_bg3.png": 1507,
	"./2025/topic900/tab/person_tab.png": 277,
	"./2025/topic900/tab/tab1_1.png": 781,
	"./2025/topic900/tab/tab1_2.png": 782,
	"./2025/topic900/tab/tab2_1.png": 783,
	"./2025/topic900/tab/tab2_2.png": 784,
	"./2025/topic900/tab/tab2_3.png": 785,
	"./2025/topic900/tab/tab3_1.png": 786,
	"./2025/topic900/tab/tab3_2.png": 787,
	"./2025/topic900/verify/verify_bg1.png": 788,
	"./2025/topic900/verify/verify_bg2.png": 789,
	"./2025/topic900/verify/verify_bg3.png": 790,
	"./2025/topic900/verify/verify_bg4.png": 791,
	"./2025/topic900/verify/verify_icon1.png": 792,
	"./2025/topic900/verify/verify_icon2.png": 793,
	"./2025/topic900/verify/verify_icon3.png": 794,
	"./2025/topic900/verify/verify_icon4.png": 795,
	"./2025/topic900/video_3people.png": 1508,
	"./2025/topic900/video_3people_m.png": 1509,
	"./2025/topicAI/bg-risk.png": 500,
	"./2025/topicAI/bg1.png": 1510,
	"./2025/topicAI/bg2.png": 1511,
	"./2025/topicAI/h5-bg1.png": 1512,
	"./2025/topicAI/icon1.png": 501,
	"./2025/topicAI/icon2.png": 398,
	"./2025/topicAI/icon3.png": 399,
	"./2025/topicAI/img-splice-1.png": 502,
	"./2025/topicAI/img-splice-2.png": 503,
	"./2025/topicAI/img-splice-3.png": 504,
	"./2025/topicAI/section1-bg1.png": 505,
	"./2025/topicAI/section2-icon1.png": 506,
	"./2025/topicAI/section2-icon2.png": 507,
	"./2025/topicAI/section2-img1.png": 508,
	"./2025/topicAI/section2-img3.png": 1513,
	"./2025/topicAI/￼section2-img2-h5.png": 509,
	"./2025/topicAI/￼section2-img2.png": 510,
	"./2025/topicQuiz/answer_left.png": 278,
	"./2025/topicQuiz/firework.png": 1514,
	"./2025/topicQuiz/left_test.png": 279,
	"./2025/topicQuiz/not_pass.png": 280,
	"./2025/topicQuiz/pass.png": 281,
	"./2025/topicQuiz/quiz_bg.png": 1515,
	"./2025/topicQuiz/quiz_bg_1.png": 1516,
	"./2025/wPeople1.png": 1517,
	"./2025/wPeople2.png": 1518,
	"./2025/welcomeBg.png": 1519,
	"./2025/welcomeBg_m.png": 1520,
	"./2025/welcomeInfo.png": 1521,
	"./2025/welcomeStarrt.png": 1522,
	"./2025/welcome_bg_left.png": 1523,
	"./3d-speech-bubble.png": 1524,
	"./817w2.png": 511,
	"./817w3.png": 512,
	"./9881.png": 1525,
	"./9882.png": 1526,
	"./Artboard 20 1.svg": 1527,
	"./Artboard 20 2.svg": 1528,
	"./Boss-right.png": 1529,
	"./CSRealCase1-en-moblie.jpg": 796,
	"./CSRealCase1-en.jpg": 797,
	"./CSRealCase1-moblie.jpg": 798,
	"./CSRealCase1.jpg": 799,
	"./CSRealCase1.png": 1530,
	"./CSRealCase2-en-moblie.jpg": 800,
	"./CSRealCase2-en.jpg": 801,
	"./CSRealCase2-moblie.jpg": 802,
	"./CSRealCase2.jpg": 803,
	"./CSRealCase3-en-moblie.jpg": 804,
	"./CSRealCase3-en.jpg": 805,
	"./CSRealCase3-moblie.jpg": 806,
	"./CSRealCase3.jpg": 807,
	"./CommonInternetWhalingAttacks1.jpg": 808,
	"./CommonInternetWhalingAttacks1.png": 1531,
	"./CommonInternetWhalingAttacks2.jpg": 809,
	"./CommonInternetWhalingAttacks2.png": 1532,
	"./CommonInternetWhalingAttacks3.jpg": 810,
	"./CommonInternetWhalingAttacks3.png": 1533,
	"./CommonInternetWhalingAttacks4.jpg": 811,
	"./CommonInternetWhalingAttacks4.png": 1534,
	"./CustomerRealCase1-en-moblie.jpg": 812,
	"./CustomerRealCase1-en.jpg": 813,
	"./CustomerRealCase1-moblie.jpg": 814,
	"./CustomerRealCase1.jpg": 815,
	"./E-commerce-gif1.gif": 1535,
	"./E-commerce-gif2.gif": 1536,
	"./E-commerce-gif3.gif": 1537,
	"./E-commerce-gif4.gif": 1538,
	"./E-commerceRealCase1-en.jpg": 816,
	"./E-commerceRealCase1-moblie-en.jpg": 817,
	"./E-commerceRealCase1-moblie.jpg": 818,
	"./E-commerceRealCase1.jpg": 819,
	"./E-commerceRealCase2-en.jpg": 820,
	"./E-commerceRealCase2-mobile.jpg": 821,
	"./E-commerceRealCase2-moblie-en.jpg": 822,
	"./E-commerceRealCase2-moblie.jpg": 823,
	"./E-commerceRealCase2.jpg": 824,
	"./Finance.png": 513,
	"./FinanceRealCase-en.jpg": 825,
	"./FinanceRealCase-mobile-en.jpg": 826,
	"./FinanceRealCase-mobile-sc.jpg": 827,
	"./FinanceRealCase-mobile.jpg": 828,
	"./FinanceRealCase-sc.jpg": 829,
	"./FinanceRealCase.jpg": 830,
	"./FinanceRealCase.png": 1539,
	"./FinanceRealCase2-en.jpg": 831,
	"./FinanceRealCase2-mobile-en.jpg": 832,
	"./FinanceRealCase2-mobile-sc.jpg": 833,
	"./FinanceRealCase2-mobile.jpg": 834,
	"./FinanceRealCase2-sc.jpg": 835,
	"./FinanceRealCase2.jpg": 836,
	"./G5584.png": 1540,
	"./Group5600.png": 1541,
	"./HRRealCase-en.jpg": 837,
	"./HRRealCase-mobile-en.jpg": 838,
	"./HRRealCase-mobile.jpg": 839,
	"./HRRealCase.jpg": 840,
	"./IT.png": 514,
	"./ITRealCase.svg": 1542,
	"./ITRealCase1-en.jpg": 841,
	"./ITRealCase1-moblie-en.jpg": 842,
	"./ITRealCase1-moblie.jpg": 843,
	"./ITRealCase1.jpg": 844,
	"./ITRealCase2-en.jpg": 845,
	"./ITRealCase2-moblie-en.jpg": 846,
	"./ITRealCase2-moblie.jpg": 847,
	"./ITRealCase2.jpg": 848,
	"./ITRealCase3-en.jpg": 849,
	"./ITRealCase3-moblie-en.jpg": 850,
	"./ITRealCase3-moblie.jpg": 851,
	"./ITRealCase3.jpg": 852,
	"./IndexPrompt.jpg": 853,
	"./IndexPrompt.png": 1543,
	"./Introduction.png": 1544,
	"./Lady.svg": 1545,
	"./Link.png": 153,
	"./Ma009-1.svg": 1546,
	"./Ma009-2.svg": 1547,
	"./Ma009-3.svg": 1548,
	"./Ma009-4.svg": 1549,
	"./Ma009-5.svg": 1550,
	"./Ma009-6.svg": 1551,
	"./Manufacturing.png": 1552,
	"./MarketRealCase.jpg": 854,
	"./MarketRealCase1-en-moblie.jpg": 855,
	"./MarketRealCase1-en.jpg": 856,
	"./MarketRealCase1-moblie.jpg": 857,
	"./MarketRealCase1.jpg": 858,
	"./MarketRealCase1.png": 1553,
	"./MarketRealCase1.svg": 1554,
	"./MarketRealCase2-en-moblie.jpg": 859,
	"./MarketRealCase2-en.jpg": 860,
	"./MarketRealCase2-moblie.jpg": 861,
	"./MarketRealCase2.jpg": 862,
	"./MarketRealCase3-en.jpg": 863,
	"./Mc001-Picture1.png": 1555,
	"./Mc001-Picture2.png": 1556,
	"./Mc001-Picture3.png": 1557,
	"./NGORealCase1-en.jpg": 864,
	"./NGORealCase1-moblie-en.jpg": 865,
	"./NGORealCase1-moblie.jpg": 866,
	"./NGORealCase1.jpg": 867,
	"./NGORealCase2-en.jpg": 868,
	"./NGORealCase2-moblie-en.jpg": 869,
	"./NGORealCase2-moblie.jpg": 870,
	"./NGORealCase2.jpg": 871,
	"./PPII.png": 1558,
	"./Pictureds1.png": 1559,
	"./Pictureds10.png": 1560,
	"./Pictureds2.png": 1561,
	"./Pictureds3.png": 1562,
	"./Pictureds4.png": 1563,
	"./Pictureds5.png": 1564,
	"./Pictureds6.png": 1565,
	"./Pictureds7.png": 1566,
	"./Pictureds8.png": 1567,
	"./Pictureds9.png": 1568,
	"./PwC_Repre_Illus_Iso_02_IoT_RGB.png": 1569,
	"./PwC_Repre_Illus_Iso_05_Chatbot_RGB.png": 1570,
	"./RealCase-en.png": 1571,
	"./RealCase-mobile-en.jpg": 872,
	"./RealCase-mobile-sc.jpg": 873,
	"./RealCase-sc.jpg": 874,
	"./RealCase.mobile.jpg": 875,
	"./RealCase.png": 1572,
	"./Realcase-socialMedia-en.png": 1573,
	"./Realcase-socialMedia-mobile-en.png": 1574,
	"./Realcase-socialMedia-mobile.jpg": 876,
	"./Realcase-socialMedia.jpg": 877,
	"./Shield.png": 515,
	"./Software-Downloading-icon1.png": 1575,
	"./Software-Downloading-icon2.png": 1576,
	"./Software-Downloading-icon3.png": 1577,
	"./Software-Downloading-icon4.png": 1578,
	"./Software-Downloading-img1.png": 1579,
	"./Software-Downloading-img2.png": 1580,
	"./Software-Downloading-img3.png": 1581,
	"./Software-Downloading-img4.png": 1582,
	"./a001-01.svg": 1583,
	"./a001-02.svg": 1584,
	"./a001-03.svg": 1585,
	"./a001-04.svg": 1586,
	"./a001-05.svg": 1587,
	"./a001-06.svg": 1588,
	"./a001-ransomware-01.png": 1589,
	"./a001-ransomware-02.png": 1590,
	"./a001-ransomware-03.png": 1591,
	"./a001-ransomware-04.png": 1592,
	"./a001-whatsapp-01.png": 1593,
	"./a001-whatsapp-02.png": 1594,
	"./a001-whatsapp-03.png": 1595,
	"./a004-a.jpg": 878,
	"./a004-b.jpg": 879,
	"./a004-example1-en.jpg": 880,
	"./a004-example1-sc.jpg": 881,
	"./a004-example1.jpg": 882,
	"./a004-example2.jpg": 883,
	"./a004-example3.jpg": 884,
	"./a004-mary-left.svg": 1596,
	"./a005-5.png": 1597,
	"./a005-6.png": 1598,
	"./a005-general2024.png": 1599,
	"./a006-a.png": 1600,
	"./a006-b.png": 1601,
	"./a006-c.png": 1602,
	"./a008-1.png": 1603,
	"./a008-1.svg": 1604,
	"./a008-2.png": 1605,
	"./a008-2.svg": 1606,
	"./a008-3.png": 1607,
	"./a008-3.svg": 1608,
	"./a008-4.png": 1609,
	"./a008-4.svg": 1610,
	"./a008-5.png": 1611,
	"./a008-5.svg": 1612,
	"./a008-6.svg": 1613,
	"./a008-7.svg": 1614,
	"./a008-A.svg": 1615,
	"./a008-B.svg": 1616,
	"./a008-C.svg": 1617,
	"./a008-D.svg": 1618,
	"./a008-tip.jpg": 885,
	"./a009-1.png": 1619,
	"./a009-1.svg": 1620,
	"./a009-2.png": 1621,
	"./a009-2.svg": 1622,
	"./a009-3.png": 1623,
	"./a009-3.svg": 1624,
	"./a009-4.png": 1625,
	"./a009-4.svg": 1626,
	"./a009-5.svg": 1627,
	"./a009-6.svg": 1628,
	"./a009-ransomware-01.svg": 1629,
	"./a009-ransomware-02.svg": 1630,
	"./a009-ransomware-03.svg": 1631,
	"./a009-ransomware-04.svg": 1632,
	"./a009-tip1.jpg": 886,
	"./a009-tip2.jpg": 887,
	"./a009-tip3.jpg": 888,
	"./a010-1.png": 1633,
	"./a010-2.png": 1634,
	"./a010-3.png": 1635,
	"./a010-4.png": 1636,
	"./a011-01.jpg": 889,
	"./a011-010.jpg": 890,
	"./a011-011.jpg": 891,
	"./a011-012.jpg": 892,
	"./a011-02.jpg": 893,
	"./a011-03.jpg": 894,
	"./a011-04.jpg": 895,
	"./a011-05.jpg": 896,
	"./a011-06.jpg": 897,
	"./a011-07.jpg": 898,
	"./a011-08.jpg": 899,
	"./a011-09.jpg": 900,
	"./a011-1.png": 1637,
	"./a011-1.svg": 1638,
	"./a011-2.png": 1639,
	"./a011-2.svg": 1640,
	"./a011-3.png": 1641,
	"./a011-3.svg": 1642,
	"./a011-4.png": 1643,
	"./a011-4.svg": 1644,
	"./a011-5.png": 1645,
	"./a011-5.svg": 1646,
	"./a011-6.png": 1647,
	"./a011-6.svg": 1648,
	"./a011-7.svg": 1649,
	"./a011-PPII-1.svg": 1650,
	"./a011-PPII-2.svg": 1651,
	"./a011-PPII-3.svg": 1652,
	"./a011-PPII-4.svg": 1653,
	"./a011-PPII-5.svg": 1654,
	"./a011-PPII-6.svg": 1655,
	"./a011-example1.jpg": 901,
	"./a011-example10.png": 1656,
	"./a011-example11_en.png": 1657,
	"./a011-example11_sc.png": 1658,
	"./a011-example11_tc.png": 1659,
	"./a011-example13_en.png": 1660,
	"./a011-example13_sc.png": 1661,
	"./a011-example13_tc.png": 1662,
	"./a011-example2.jpg": 902,
	"./a011-example3.jpg": 903,
	"./a011-example4.png": 1663,
	"./a011-example5.jpg": 904,
	"./a011-example6.jpg": 905,
	"./a011-example7.jpg": 906,
	"./a011-example8.jpg": 907,
	"./a011-example9.png": 1664,
	"./a011-fsi-01.svg": 1665,
	"./a011-fsi-02.svg": 1666,
	"./a011-fsi-03.svg": 1667,
	"./a011-fsi-04.svg": 1668,
	"./a011-fsi-05.svg": 1669,
	"./a011-fsi-06.svg": 1670,
	"./a011-fsi-07.svg": 1671,
	"./a011-fsi-08.svg": 1672,
	"./a011-fsi-09.svg": 1673,
	"./a011-fsi-10.svg": 1674,
	"./a011-general2024-example1.png": 1675,
	"./a011-general2024-example2.png": 1676,
	"./a011-general2024-example3.png": 1677,
	"./a011-general2024-example4.png": 1678,
	"./a011-market-1.svg": 1679,
	"./a011-market-2.svg": 1680,
	"./a011-market-3.svg": 1681,
	"./a011-market-4.svg": 1682,
	"./a011-market-5.svg": 1683,
	"./a011-market-6.svg": 1684,
	"./a011-startup-01.svg": 1685,
	"./a011-startup-02.svg": 1686,
	"./a011-startup-03.svg": 1687,
	"./a011-startup-04.svg": 1688,
	"./a011-startup-05.svg": 1689,
	"./a011-startup-06.svg": 1690,
	"./a011-startup-1.svg": 1691,
	"./a011-startup-2.svg": 1692,
	"./a011-startup-3.svg": 1693,
	"./a011-startup-4.svg": 1694,
	"./a011-startup-5.svg": 1695,
	"./a012-1.png": 1696,
	"./a012-1.svg": 1697,
	"./a012-10.png": 1698,
	"./a012-10.svg": 1699,
	"./a012-11.png": 1700,
	"./a012-12.png": 1701,
	"./a012-13.png": 1702,
	"./a012-14.png": 1703,
	"./a012-15.png": 1704,
	"./a012-2.png": 1705,
	"./a012-2.svg": 1706,
	"./a012-3.png": 1707,
	"./a012-3.svg": 1708,
	"./a012-4.png": 1709,
	"./a012-4.svg": 1710,
	"./a012-5.png": 1711,
	"./a012-5.svg": 1712,
	"./a012-6.png": 1713,
	"./a012-6.svg": 1714,
	"./a012-7.png": 1715,
	"./a012-7.svg": 1716,
	"./a012-8.png": 1717,
	"./a012-8.svg": 1718,
	"./a012-9.png": 1719,
	"./a012-9.svg": 1720,
	"./a012-market-1.svg": 1721,
	"./a012-market-10.svg": 1722,
	"./a012-market-2.svg": 1723,
	"./a012-market-3.svg": 1724,
	"./a012-market-4.svg": 1725,
	"./a012-market-5.svg": 1726,
	"./a012-market-6.svg": 1727,
	"./a012-market-7.svg": 1728,
	"./a012-market-8.svg": 1729,
	"./a012-market-9.svg": 1730,
	"./a012-market-line-1.svg": 1731,
	"./a012-market-line-10.svg": 1732,
	"./a012-market-line-2.svg": 1733,
	"./a012-market-line-3.svg": 1734,
	"./a012-market-line-4.svg": 1735,
	"./a012-market-line-5.svg": 1736,
	"./a012-market-line-6.svg": 1737,
	"./a012-market-line-7.svg": 1738,
	"./a012-market-line-8.svg": 1739,
	"./a012-market-line-9.svg": 1740,
	"./a013-1.png": 1741,
	"./a013-2.png": 1742,
	"./a013-3.png": 1743,
	"./a013-4.png": 1744,
	"./a013-a.png": 1745,
	"./a013-b.png": 1746,
	"./a013-c.png": 1747,
	"./a013-d.png": 1748,
	"./a014-long.svg": 1749,
	"./a014-longer.svg": 1750,
	"./a014.svg": 1751,
	"./a015-1.svg": 1752,
	"./a015-2.svg": 1753,
	"./a015-3.svg": 1754,
	"./a015-4.svg": 1755,
	"./a015-arrow.svg": 282,
	"./a016-1.jpg": 908,
	"./a016-2.jpg": 909,
	"./a016-3.jpg": 910,
	"./a016-4.jpg": 911,
	"./a016-4.png": 1756,
	"./a016-5.jpg": 912,
	"./a016-5.png": 1757,
	"./a016-6.jpg": 913,
	"./a016-6.png": 1758,
	"./a016-7.png": 1759,
	"./a016-8.png": 1760,
	"./a016-attention-market.svg": 283,
	"./a016-attention.svg": 284,
	"./a016-market-1.jpg": 914,
	"./a016-market-2.jpg": 915,
	"./a016-market-3.jpg": 916,
	"./a016-market-4.jpg": 917,
	"./a017-1.svg": 1761,
	"./a017-10.svg": 1762,
	"./a017-2.svg": 1763,
	"./a017-3.svg": 1764,
	"./a017-4.svg": 1765,
	"./a017-5.svg": 1766,
	"./a017-6.svg": 1767,
	"./a017-7.svg": 1768,
	"./a017-8.svg": 1769,
	"./a017-9.svg": 1770,
	"./a017-a.svg": 1771,
	"./a017-b.svg": 1772,
	"./a017-c.svg": 1773,
	"./a017-d.svg": 1774,
	"./a017-e.svg": 1775,
	"./a017-f.svg": 1776,
	"./a017-g.svg": 1777,
	"./a017-h.svg": 1778,
	"./a017-i.svg": 1779,
	"./a017-j.svg": 1780,
	"./a017-line1.svg": 1781,
	"./a017-line10.svg": 1782,
	"./a017-line2.svg": 1783,
	"./a017-line3.svg": 1784,
	"./a017-line4.svg": 1785,
	"./a017-line5.svg": 1786,
	"./a017-line6.svg": 1787,
	"./a017-line7.svg": 1788,
	"./a017-line8.svg": 1789,
	"./a017-line9.svg": 1790,
	"./a017-market-1.svg": 1791,
	"./a017-market-10.svg": 1792,
	"./a017-market-2.svg": 1793,
	"./a017-market-3.svg": 1794,
	"./a017-market-4.svg": 1795,
	"./a017-market-5.svg": 1796,
	"./a017-market-6.svg": 1797,
	"./a017-market-7.svg": 1798,
	"./a017-market-8.svg": 1799,
	"./a017-market-9.svg": 1800,
	"./a018-1.svg": 1801,
	"./a018-10.svg": 1802,
	"./a018-2.svg": 1803,
	"./a018-3.svg": 1804,
	"./a018-4.svg": 1805,
	"./a018-5.svg": 1806,
	"./a018-6.svg": 1807,
	"./a018-7.svg": 1808,
	"./a018-8.svg": 1809,
	"./a018-9.svg": 1810,
	"./a019-1.svg": 1811,
	"./a019-2.svg": 1812,
	"./a019-3.svg": 1813,
	"./a019-4.svg": 1814,
	"./a019-5.svg": 1815,
	"./a019-tip-en.jpg": 918,
	"./a019-tip.jpg": 919,
	"./a019.gif": 1816,
	"./a020-cs-1.svg": 1817,
	"./a020-cs-2.svg": 1818,
	"./a020-cs-3.svg": 1819,
	"./a020-cs-4.svg": 1820,
	"./a020-it-1.svg": 1821,
	"./a020-it-2.svg": 1822,
	"./a020-it-3.svg": 1823,
	"./a020-it-4.svg": 1824,
	"./a020-market-1.svg": 1825,
	"./a020-market-2.svg": 1826,
	"./a020-market-3.svg": 1827,
	"./a020-market-4.svg": 1828,
	"./a020-ngo-1.svg": 1829,
	"./a020-ngo-2.svg": 1830,
	"./a020-ngo-3.svg": 1831,
	"./a020-ngo-4.svg": 1832,
	"./a020-ngo-5.svg": 1833,
	"./a021-viewmore-en.jpg": 920,
	"./a021-viewmore-en.png": 1834,
	"./a021-viewmore-fsi.jpg": 921,
	"./a021-viewmore.jpg": 922,
	"./a021-viewmore.png": 1835,
	"./a022-market.svg": 1836,
	"./a023-01.png": 923,
	"./a023-02.png": 924,
	"./a023-03.png": 925,
	"./a023-04.png": 926,
	"./a023-05.png": 927,
	"./a023-06.png": 928,
	"./a023-1.png": 929,
	"./a023-2.png": 930,
	"./a023-3.png": 931,
	"./a023-4.png": 932,
	"./a023-example1.png": 933,
	"./a023-example2.png": 934,
	"./a023-example3.png": 935,
	"./a023-fsi1-short.png": 936,
	"./a023-fsi2-short.png": 937,
	"./a023-fsi3-short.png": 938,
	"./a023-fsi4-short.png": 939,
	"./a023-fsi5-short.png": 940,
	"./a023-short1.jpg": 428,
	"./a023-short2.jpg": 429,
	"./a023-short3.jpg": 430,
	"./a023-short4.jpg": 431,
	"./a023-short5.jpg": 432,
	"./a023-short6.jpg": 433,
	"./a023-startup1-en-short.png": 941,
	"./a023-startup1-en.png": 942,
	"./a023-startup1-short.png": 943,
	"./a023-startup1.png": 944,
	"./a023-startup2-en-short.png": 945,
	"./a023-startup2-en.png": 946,
	"./a023-startup2-short.png": 947,
	"./a023-startup2.png": 948,
	"./a023-startup3-en-short.png": 949,
	"./a023-startup3-en.png": 950,
	"./a023-startup3-short.png": 951,
	"./a023-startup3.png": 952,
	"./a023-startup4-en-short.png": 953,
	"./a023-startup4-en.png": 954,
	"./a023-startup4-short.png": 955,
	"./a023-startup4.png": 956,
	"./a023-startup5-en-short.png": 957,
	"./a023-startup5-en.png": 958,
	"./a023-startup5-short.png": 959,
	"./a023-startup5.png": 960,
	"./a024-1.gif": 1837,
	"./a024-1.svg": 1838,
	"./a024-10.svg": 1839,
	"./a024-11.svg": 1840,
	"./a024-12.svg": 1841,
	"./a024-2.gif": 1842,
	"./a024-2.svg": 1843,
	"./a024-3.svg": 1844,
	"./a024-4.svg": 1845,
	"./a024-5.svg": 1846,
	"./a024-6.svg": 1847,
	"./a024-7.svg": 1848,
	"./a024-8.svg": 1849,
	"./a024-9.svg": 1850,
	"./a024-startup-1.svg": 1851,
	"./a024-startup-2.svg": 1852,
	"./a024-startup-3.svg": 1853,
	"./a024-startup-4.svg": 1854,
	"./a024-startup-5.svg": 1855,
	"./a024-startup-6.svg": 1856,
	"./a026-example1-en.png": 1857,
	"./a026-example1.jpg": 961,
	"./a026-example2.jpg": 962,
	"./a026-example3.jpg": 963,
	"./a026-example4.jpg": 964,
	"./a026-example5.jpg": 965,
	"./a026-example6.jpg": 966,
	"./a026-example7.jpg": 967,
	"./a026-example8.png": 1858,
	"./a028-1.png": 968,
	"./a028-1.svg": 1859,
	"./a028-2.png": 969,
	"./a028-2.svg": 1860,
	"./a028-3.png": 970,
	"./a028-3.svg": 1861,
	"./a028-4.png": 971,
	"./a028-4.svg": 1862,
	"./a028-5.png": 972,
	"./a028-5.svg": 1863,
	"./a028-6.png": 973,
	"./a028-example1.jpg": 974,
	"./a028-example2.jpg": 975,
	"./a028-example3.jpg": 976,
	"./a033.png": 1864,
	"./a036-1.svg": 1865,
	"./a036-2.svg": 1866,
	"./a036-3.svg": 1867,
	"./a036-4.svg": 1868,
	"./a036-5.svg": 1869,
	"./a037-1.svg": 1870,
	"./a037-10.svg": 1871,
	"./a037-2.svg": 1872,
	"./a037-3.svg": 1873,
	"./a037-4.svg": 1874,
	"./a037-5.svg": 1875,
	"./a037-6.svg": 1876,
	"./a037-7.svg": 1877,
	"./a037-8.svg": 1878,
	"./a037-9.svg": 1879,
	"./a037-IDNumber-08.png": 1880,
	"./a037-a.jpg": 977,
	"./a037-address-02.png": 1881,
	"./a037-b.jpg": 978,
	"./a037-biometricData-10.png": 1882,
	"./a037-c.jpg": 979,
	"./a037-d.jpg": 980,
	"./a037-dateofBirth-05.png": 1883,
	"./a037-driverLicenseNumber-06.png": 1884,
	"./a037-e.jpg": 981,
	"./a037-emailAddress-04.png": 1885,
	"./a037-f.jpg": 982,
	"./a037-financialAccount-09.png": 1886,
	"./a037-g.jpg": 983,
	"./a037-h.jpg": 984,
	"./a037-i.jpg": 985,
	"./a037-j.jpg": 986,
	"./a037-k.jpg": 987,
	"./a037-l.jpg": 988,
	"./a037-m.jpg": 989,
	"./a037-n.jpg": 990,
	"./a037-name-01.png": 1887,
	"./a037-passportNumber-07.png": 1888,
	"./a037-phoneNumber-03.png": 1889,
	"./a037-student-1-en.png": 1890,
	"./a037-student-1-sc.png": 1891,
	"./a037-student-1.png": 1892,
	"./a037-student-2.png": 1893,
	"./a037-student-t3-1.svg": 1894,
	"./a037-student-t3-10.svg": 1895,
	"./a037-student-t3-2.svg": 1896,
	"./a037-student-t3-3.svg": 1897,
	"./a037-student-t3-4.svg": 1898,
	"./a037-student-t3-5.svg": 1899,
	"./a037-student-t3-6.svg": 1900,
	"./a037-student-t3-7.svg": 1901,
	"./a037-student-t3-8.svg": 1902,
	"./a037-student-t3-9.svg": 1903,
	"./a037-student-t3-s3-1.svg": 1904,
	"./a037-student-t3-s3-10.svg": 1905,
	"./a037-student-t3-s3-2.svg": 1906,
	"./a037-student-t3-s3-3.svg": 1907,
	"./a037-student-t3-s3-4.svg": 1908,
	"./a037-student-t3-s3-5.svg": 1909,
	"./a037-student-t3-s3-6.svg": 1910,
	"./a037-student-t3-s3-7.svg": 1911,
	"./a037-student-t3-s3-8.svg": 1912,
	"./a037-student-t3-s3-9.svg": 1913,
	"./a038-1.svg": 1914,
	"./a038-2.svg": 1915,
	"./a038-3.svg": 1916,
	"./a038-4.svg": 1917,
	"./a038-5.svg": 1918,
	"./a038-6.svg": 1919,
	"./a038-7.svg": 1920,
	"./a041-1.png": 1921,
	"./a041-2.png": 1922,
	"./a041-3.png": 1923,
	"./a041-4.png": 1924,
	"./a041-5.png": 1925,
	"./a041-fsi1-bottom.png": 1926,
	"./a041-fsi1-top.png": 1927,
	"./a041-fsi2-bottom.png": 1928,
	"./a041-fsi2-top.png": 1929,
	"./a041-fsi3-bottom.png": 1930,
	"./a041-fsi3-top.png": 1931,
	"./a041-fsi4-bottom.png": 1932,
	"./a041-fsi4-top.png": 1933,
	"./a041-fsi5-bottom.png": 1934,
	"./a041-fsi5-top.png": 1935,
	"./a044-1.png": 1936,
	"./a044-2.png": 1937,
	"./a044-3.png": 1938,
	"./a044-4.png": 1939,
	"./a044-5.png": 1940,
	"./a044-6.png": 1941,
	"./a046-1.png": 1942,
	"./a046-2.png": 1943,
	"./a046-3.png": 1944,
	"./a046-4.png": 1945,
	"./a046-5.png": 1946,
	"./a046-6.png": 1947,
	"./a047-icon1.png": 1948,
	"./a047-icon2.png": 1949,
	"./a047-icon3.png": 1950,
	"./a047-icon4.png": 1951,
	"./a047-icon5.png": 1952,
	"./a047-icon6.png": 1953,
	"./a047-icon7.png": 1954,
	"./a047-icon8.png": 1955,
	"./a047-vector-purple.png": 1956,
	"./a047-vector-red.png": 1957,
	"./a047-vector.png": 1958,
	"./aiSecurity.png": 1959,
	"./aiSecurityRealcase-en.jpg": 991,
	"./aiSecurityRealcase-mobile-en.jpg": 992,
	"./aiSecurityRealcase-mobile.jpg": 993,
	"./aiSecurityRealcase.jpg": 994,
	"./animation-arrow.gif": 126,
	"./animation-arrow10.gif": 1960,
	"./animation-arrow11.gif": 1961,
	"./animation-arrow12.gif": 1962,
	"./animation-arrow13.gif": 1963,
	"./animation-arrow2.gif": 1964,
	"./animation-arrow20.gif": 1965,
	"./animation-arrow21.gif": 1966,
	"./animation-arrow26.gif": 1967,
	"./animation-arrow3.gif": 1968,
	"./animation-arrow4.gif": 1969,
	"./animation-arrow5.gif": 1970,
	"./animation-arrow6.gif": 1971,
	"./animation-arrow7.gif": 1972,
	"./animation-arrow8.gif": 1973,
	"./animation-arrow9.gif": 1974,
	"./animation-quiz.gif": 1975,
	"./animation004-1.png": 61,
	"./animation004-2.png": 1976,
	"./animation021-01.svg": 1977,
	"./animation021-02.svg": 1978,
	"./animation021-03.svg": 1979,
	"./animation021-04.svg": 1980,
	"./animation021-05.svg": 1981,
	"./animation021-06.svg": 1982,
	"./animation_password.gif": 1983,
	"./animation_password_en.gif": 1984,
	"./animation_point.gif": 4,
	"./arrow-left-long.png": 16,
	"./arrow-left.png": 154,
	"./arrow-right-long.png": 17,
	"./arrow-right.png": 155,
	"./arrow.png": 94,
	"./avater1.png": 1985,
	"./avater2.png": 1986,
	"./avater3.png": 1987,
	"./avater4.png": 1988,
	"./avater5.png": 1989,
	"./avater6.png": 58,
	"./avater7.png": 54,
	"./avater8.png": 1990,
	"./avater9.png": 1991,
	"./avaterStudent.svg": 1992,
	"./boss-right2.png": 1993,
	"./bp1.png": 1994,
	"./bp10.png": 1995,
	"./bp11.png": 1996,
	"./bp2.png": 1997,
	"./bp3.png": 1998,
	"./bp4.png": 1999,
	"./bp5.png": 2000,
	"./bp6.png": 2001,
	"./bp7.png": 2002,
	"./bp8.png": 2003,
	"./bp9.png": 2004,
	"./business-problem1-en.png": 2005,
	"./business-problem1-sc.png": 2006,
	"./business-problem1.png": 2007,
	"./business-problem2.gif": 2008,
	"./business-problem3.png": 2009,
	"./business-problem4-en.png": 2010,
	"./business-problem4.png": 2011,
	"./business-problem5-en.png": 2012,
	"./business-problem5-sc.png": 2013,
	"./business-problem5.png": 2014,
	"./c001-E-commerce-1.jpg": 995,
	"./c001-E-commerce-2.jpg": 996,
	"./c001-E-commerce-3.jpg": 997,
	"./c001-E-commerce-4.jpg": 998,
	"./c001-E-commerce-5.jpg": 999,
	"./c001-E-commerce-6.jpg": 1000,
	"./c001-Picture1.jpg": 1001,
	"./c001-Picture2.jpg": 1002,
	"./c001-Picture3.jpg": 1003,
	"./c001-fsi-1.jpg": 1004,
	"./c001-fsi-2.jpg": 1005,
	"./c001-fsi-3.jpg": 1006,
	"./c001-fsi-4.jpg": 1007,
	"./c001-general2024-1.png": 2015,
	"./c001-general2024-2.png": 2016,
	"./c001-general2024-3.png": 2017,
	"./c001-general2024-4.png": 2018,
	"./c001-general2024-5.png": 2019,
	"./c001-general2024-6.png": 2020,
	"./c001-general2024-7.png": 2021,
	"./c001-general2024-8.png": 2022,
	"./c001-ngo-1.jpg": 1008,
	"./c001-ngo-2.jpg": 1009,
	"./c001-ngo-3.jpg": 1010,
	"./c001-ngo-4.jpg": 1011,
	"./c001-ngo-5.jpg": 1012,
	"./c001-student-1.jpg": 1013,
	"./c001-student-2.jpg": 1014,
	"./c001-student-3.jpg": 1015,
	"./c001-student-4.jpg": 1016,
	"./c001-student-5.jpg": 1017,
	"./c001-student-6.jpg": 1018,
	"./c001-student-7.jpg": 1019,
	"./c001-student-8.jpg": 1020,
	"./c002-1.png": 2023,
	"./c002-1.svg": 2024,
	"./c002-PPII-1.svg": 2025,
	"./c002-PPII-10.svg": 2026,
	"./c002-PPII-11.svg": 2027,
	"./c002-PPII-12.svg": 2028,
	"./c002-PPII-13.svg": 2029,
	"./c002-PPII-14.svg": 2030,
	"./c002-PPII-15.svg": 2031,
	"./c002-PPII-16.svg": 2032,
	"./c002-PPII-2.svg": 2033,
	"./c002-PPII-3.svg": 2034,
	"./c002-PPII-4.svg": 2035,
	"./c002-PPII-6.svg": 2036,
	"./c002-PPII-7.svg": 2037,
	"./c002-PPII-8.svg": 2038,
	"./c002-PPII-9.svg": 2039,
	"./c002-eCommerce.png": 2040,
	"./c002-example1.jpg": 1021,
	"./c002-general2024-example1.jpg": 1022,
	"./c002-pic.png": 2041,
	"./c002-whatsapp-01-en.png": 2042,
	"./c002-whatsapp-01.png": 2043,
	"./c002-whatsapp-02-en.png": 2044,
	"./c002-whatsapp-02.png": 2045,
	"./c003-man-left.png": 2046,
	"./c003-right-lady.png": 2047,
	"./c005-1.png": 2048,
	"./c005-10.png": 2049,
	"./c005-11.png": 2050,
	"./c005-12.png": 2051,
	"./c005-13.png": 2052,
	"./c005-2.png": 2053,
	"./c005-3.png": 2054,
	"./c005-4.png": 2055,
	"./c005-5.png": 2056,
	"./c005-6.png": 2057,
	"./c005-7.png": 2058,
	"./c005-8.png": 2059,
	"./c005-9.png": 2060,
	"./c005-arrow01.png": 516,
	"./c005-arrow02.png": 517,
	"./c005-whatsapp-01-en.png": 2061,
	"./c005-whatsapp-01.png": 2062,
	"./c005-whatsapp-02-en.png": 2063,
	"./c005-whatsapp-02.png": 2064,
	"./c005-whatsapp-03-en.png": 2065,
	"./c005-whatsapp-03.png": 2066,
	"./c006-1.jpg": 1023,
	"./c006-2.jpg": 1024,
	"./c006-3.jpg": 1025,
	"./c006-4.jpg": 1026,
	"./c006-5.gif": 2067,
	"./c006-5.jpg": 1027,
	"./c006-6.gif": 2068,
	"./c006-6.jpg": 1028,
	"./c006-a.jpg": 1029,
	"./c006-b.jpg": 1030,
	"./c006-b.png": 2069,
	"./c006-c.jpg": 1031,
	"./c006-c.png": 2070,
	"./c006-d.jpg": 1032,
	"./c007-1.jpg": 1033,
	"./c007-bg.jpg": 1034,
	"./c008-1.png": 2071,
	"./c008-2.png": 2072,
	"./c008-2.svg": 2073,
	"./c008-3.svg": 2074,
	"./c008-board.svg": 2075,
	"./c008-board1.svg": 2076,
	"./c010-1.png": 2077,
	"./c010-2.png": 2078,
	"./c010-3.png": 2079,
	"./c010-4.png": 2080,
	"./c013-1.png": 2081,
	"./c013-2.png": 2082,
	"./calendar.png": 285,
	"./can-do.png": 2083,
	"./can-do.svg": 2084,
	"./can-do1.png": 2085,
	"./can-not-do.png": 2086,
	"./ceritificate-background.png": 2087,
	"./cert/cert-E-commerce-HKIRC.jpg": 1035,
	"./cert/cert-E-commerce-consumer.jpg": 1036,
	"./cert/cert-E-commerce-cpttm.jpg": 434,
	"./cert/cert-E-commerce-hkgcsmeaa.jpg": 1037,
	"./cert/cert-customer-HKIRC.jpg": 1038,
	"./cert/cert-customer-consumer.jpg": 1039,
	"./cert/cert-customer-cpttm.jpg": 435,
	"./cert/cert-customer-hkgcsmeaa.jpg": 1040,
	"./cert/cert-finance-HKIRC-sc.jpg": 1041,
	"./cert/cert-finance-HKIRC.jpg": 1042,
	"./cert/cert-finance-consumer-sc.jpg": 1043,
	"./cert/cert-finance-consumer.jpg": 1044,
	"./cert/cert-finance-cpttm-sc.jpg": 436,
	"./cert/cert-finance-cpttm.jpg": 437,
	"./cert/cert-finance-hkgcsmeaa-sc.jpg": 1045,
	"./cert/cert-finance-hkgcsmeaa.jpg": 1046,
	"./cert/cert-fsi-HKIRC-sc.jpg": 1047,
	"./cert/cert-fsi-HKIRC.jpg": 1048,
	"./cert/cert-fsi-consumer-sc.jpg": 1049,
	"./cert/cert-fsi-consumer.jpg": 1050,
	"./cert/cert-fsi-cpttm-sc.jpg": 438,
	"./cert/cert-fsi-cpttm.jpg": 439,
	"./cert/cert-fsi-hkgcsmeaa-sc.jpg": 1051,
	"./cert/cert-fsi-hkgcsmeaa.jpg": 1052,
	"./cert/cert-general-staff-HKIRC-sc.jpg": 1053,
	"./cert/cert-general-staff-HKIRC.jpg": 1054,
	"./cert/cert-general-staff-a-HKIRC-sc.jpg": 1055,
	"./cert/cert-general-staff-a-HKIRC.jpg": 1056,
	"./cert/cert-general-staff-a-consumer-sc.jpg": 1057,
	"./cert/cert-general-staff-a-consumer.jpg": 1058,
	"./cert/cert-general-staff-a-cpttm-sc.jpg": 440,
	"./cert/cert-general-staff-a-cpttm.jpg": 441,
	"./cert/cert-general-staff-a-hkgcsmeaa-sc.jpg": 1059,
	"./cert/cert-general-staff-a-hkgcsmeaa.jpg": 1060,
	"./cert/cert-general-staff-consumer-sc.jpg": 1061,
	"./cert/cert-general-staff-consumer.jpg": 1062,
	"./cert/cert-general-staff-cpttm-sc.jpg": 442,
	"./cert/cert-general-staff-cpttm.jpg": 443,
	"./cert/cert-general-staff-hkgcsmeaa-sc.jpg": 1063,
	"./cert/cert-general-staff-hkgcsmeaa.jpg": 1064,
	"./cert/cert-general2024-HKIRC-sc.jpg": 1065,
	"./cert/cert-general2024-HKIRC.jpg": 1066,
	"./cert/cert-general2024-consumer-sc.jpg": 1067,
	"./cert/cert-general2024-consumer.jpg": 1068,
	"./cert/cert-general2024-cpttm-sc.jpg": 370,
	"./cert/cert-general2024-cpttm.jpg": 371,
	"./cert/cert-general2024-hkgcsmeaa-sc.jpg": 1069,
	"./cert/cert-general2024-hkgcsmeaa.jpg": 1070,
	"./cert/cert-hr-HKIRC.jpg": 1071,
	"./cert/cert-hr-consumer.jpg": 1072,
	"./cert/cert-hr-cpttm.jpg": 444,
	"./cert/cert-hr-hkgcsmeaa.jpg": 1073,
	"./cert/cert-it-HKIRC.jpg": 1074,
	"./cert/cert-it-consumer.jpg": 1075,
	"./cert/cert-it-cpttm.jpg": 445,
	"./cert/cert-it-hkgcsmeaa.jpg": 1076,
	"./cert/cert-market-HKIRC.jpg": 1077,
	"./cert/cert-market-consumer.jpg": 1078,
	"./cert/cert-market-cpttm.jpg": 446,
	"./cert/cert-market-hkgcsmeaa.jpg": 1079,
	"./cert/cert-ngo-HKIRC.jpg": 1080,
	"./cert/cert-ngo-consumer.jpg": 1081,
	"./cert/cert-ngo-cpttm.jpg": 447,
	"./cert/cert-ngo-hkgcsmeaa.jpg": 1082,
	"./cert/cert-senior-manager-HKIRC-sc.jpg": 1083,
	"./cert/cert-senior-manager-HKIRC.jpg": 1084,
	"./cert/cert-senior-manager-consumer-sc.jpg": 1085,
	"./cert/cert-senior-manager-consumer.jpg": 1086,
	"./cert/cert-senior-manager-cpttm-sc.jpg": 448,
	"./cert/cert-senior-manager-cpttm.jpg": 449,
	"./cert/cert-senior-manager-hkgcsmeaa-sc.jpg": 1087,
	"./cert/cert-senior-manager-hkgcsmeaa.jpg": 1088,
	"./cert/cert-startup-HKIRC.jpg": 1089,
	"./cert/cert-startup-consumer.jpg": 1090,
	"./cert/cert-startup-cpttm.jpg": 450,
	"./cert/cert-startup-hkgcsmeaa.jpg": 1091,
	"./cert/cert-student-HKIRC-sc.jpg": 1092,
	"./cert/cert-student-HKIRC.jpg": 1093,
	"./cert/cert-student-consumer-sc.jpg": 1094,
	"./cert/cert-student-consumer.jpg": 1095,
	"./cert/cert-student-cpttm-sc.jpg": 451,
	"./cert/cert-student-cpttm.jpg": 452,
	"./cert/cert-student-hkgcsmeaa-sc.jpg": 1096,
	"./cert/cert-student-hkgcsmeaa.jpg": 1097,
	"./chat.gif": 2088,
	"./component003-left.png": 40,
	"./component003-right.png": 41,
	"./component003Boss-left.png": 2089,
	"./component003Boss-right.png": 2090,
	"./component003Lady-right.png": 2091,
	"./component003Man-right.png": 2092,
	"./component003Student-right.svg": 2093,
	"./contacting.png": 2094,
	"./conversation-left.png": 31,
	"./conversation-right.png": 28,
	"./conversation-right2.png": 2095,
	"./courseLanding-PPII.png": 2096,
	"./courseLanding-aiSecurity.png": 2097,
	"./courseLanding-dataLeakage.png": 2098,
	"./courseLanding-ransomware-mobile.png": 2099,
	"./courseLanding-ransomware.png": 2100,
	"./courseLanding-socialMedia.png": 2101,
	"./courseLanding-whatsApp.png": 2102,
	"./courses/Finance.png": 2103,
	"./courses/Finance2.png": 2104,
	"./courses/GeneralStaff_Background.svg": 2105,
	"./courses/HR.png": 2106,
	"./courses/HotTopic_Background.svg": 2107,
	"./courses/IndustrySector_Background.svg": 2108,
	"./courses/JobPosition_Background.svg": 2109,
	"./courses/Manufacturing.png": 2110,
	"./courses/Ransomeware.png": 2111,
	"./courses/Retails.png": 2112,
	"./courses/Senior.png": 2113,
	"./courses/course1.png": 2114,
	"./courses/course10.png": 2115,
	"./courses/course8.png": 2116,
	"./courses/gf-topic1.png": 2117,
	"./cover.png": 2118,
	"./cs-a009-1.svg": 2119,
	"./cs-a009-2.svg": 2120,
	"./cs-a009-3.svg": 2121,
	"./cs-a009-4.svg": 2122,
	"./cs-a009-5.svg": 2123,
	"./cs-a009-6.svg": 2124,
	"./cs-a018-1.svg": 2125,
	"./cs-a018-10.svg": 2126,
	"./cs-a018-11.svg": 2127,
	"./cs-a018-2.svg": 2128,
	"./cs-a018-3.svg": 2129,
	"./cs-a018-4.svg": 2130,
	"./cs-a018-5.svg": 2131,
	"./cs-a018-6.svg": 2132,
	"./cs-a018-7.svg": 2133,
	"./cs-a018-8.svg": 2134,
	"./cs-a018-9.svg": 2135,
	"./cs-c001-Picture1.png": 2136,
	"./cs-c001-Picture2.png": 2137,
	"./cs-c001-Picture3.png": 2138,
	"./cs-c001-Picture4.png": 2139,
	"./cs-c003-boss-right.svg": 2140,
	"./cs-c003-right.svg": 2141,
	"./cs-gif1.gif": 2142,
	"./cs-gif2.gif": 2143,
	"./cs-gif3.gif": 2144,
	"./cs-gif4.gif": 2145,
	"./cs-welcome.svg": 2146,
	"./cyber-phishing1.png": 2147,
	"./cyber-phishing2.png": 2148,
	"./cyber-phishing3.png": 2149,
	"./cyber-phishing4.png": 2150,
	"./cybersecurity2026/close_icon.png": 2151,
	"./cybersecurity2026/error_bg.png": 2152,
	"./cybersecurity2026/finger.gif": 34,
	"./cybersecurity2026/quiz/correct_icon.png": 518,
	"./cybersecurity2026/quiz/error_icon.png": 519,
	"./cybersecurity2026/quiz/m_quiz_bg.png": 2153,
	"./cybersecurity2026/quiz/m_quiz_bg_1.png": 2154,
	"./cybersecurity2026/quiz/m_review_top_bg.png": 2155,
	"./cybersecurity2026/quiz/no_pass_bg.png": 2156,
	"./cybersecurity2026/quiz/no_pass_word_bg.png": 2157,
	"./cybersecurity2026/quiz/pass_bg.png": 2158,
	"./cybersecurity2026/quiz/pass_word_bg.png": 2159,
	"./cybersecurity2026/quiz/quiz_bg.png": 2160,
	"./cybersecurity2026/quiz/quiz_bg_1.png": 2161,
	"./cybersecurity2026/quiz/review_bg.png": 2162,
	"./cybersecurity2026/quiz/review_top_bg.png": 2163,
	"./cybersecurity2026/quiz/smile.png": 520,
	"./cybersecurity2026/quiz/upset.png": 521,
	"./cybersecurity2026/quiz_bg.png": 2164,
	"./cybersecurity2026/right_bg.png": 2165,
	"./cybersecurity2026/topic1000/bg1.png": 2166,
	"./cybersecurity2026/topic1000/bg2.png": 2167,
	"./cybersecurity2026/topic1000/bg3.png": 2168,
	"./cybersecurity2026/topic1000/bg4.png": 2169,
	"./cybersecurity2026/topic1000/bg5.png": 2170,
	"./cybersecurity2026/topic1000/bg6.png": 2171,
	"./cybersecurity2026/topic1000/bg7.png": 2172,
	"./cybersecurity2026/topic1000/date_bg.png": 2173,
	"./cybersecurity2026/topic1000/factor/factor_bubble.png": 2174,
	"./cybersecurity2026/topic1000/factor/factor_item_5.png": 2175,
	"./cybersecurity2026/topic1000/factor/factor_left_bg.png": 2176,
	"./cybersecurity2026/topic1000/factor/img.png": 2177,
	"./cybersecurity2026/topic1000/factor/img_1.png": 2178,
	"./cybersecurity2026/topic1000/factor/img_2.png": 2179,
	"./cybersecurity2026/topic1000/factor/img_3.png": 2180,
	"./cybersecurity2026/topic1000/factor/img_4.png": 2181,
	"./cybersecurity2026/topic1000/last_img.png": 522,
	"./cybersecurity2026/topic1000/light.png": 286,
	"./cybersecurity2026/topic1000/link1.png": 523,
	"./cybersecurity2026/topic1000/multiple/item1.png": 2182,
	"./cybersecurity2026/topic1000/multiple/item2.png": 2183,
	"./cybersecurity2026/topic1000/multiple/item3.png": 2184,
	"./cybersecurity2026/topic1000/multiple/m_multiple_bg.png": 2185,
	"./cybersecurity2026/topic1000/multiple/multiple_bg.png": 2186,
	"./cybersecurity2026/topic1000/person.png": 524,
	"./cybersecurity2026/topic1000/process/img.png": 2187,
	"./cybersecurity2026/topic1000/process/img_1.png": 2188,
	"./cybersecurity2026/topic1000/process/img_2.png": 2189,
	"./cybersecurity2026/topic1000/process/img_3.png": 2190,
	"./cybersecurity2026/topic1000/process/m_section1-process-bg.png": 2191,
	"./cybersecurity2026/topic1000/q_right_bg.png": 525,
	"./cybersecurity2026/topic1000/quiz_bg.png": 2192,
	"./cybersecurity2026/topic1000/quiz_bg_mobile.png": 2193,
	"./cybersecurity2026/topic1000/s3_bubble_left.png": 2194,
	"./cybersecurity2026/topic1000/s3_bubble_right.png": 2195,
	"./cybersecurity2026/topic1000/s3_item1.png": 2196,
	"./cybersecurity2026/topic1000/section-process-bg1.png": 2197,
	"./cybersecurity2026/topic1000/section-process-bg3.png": 2198,
	"./cybersecurity2026/topic1000/section1-process-bg.png": 2199,
	"./cybersecurity2026/topic1000/section1_tool.png": 2200,
	"./cybersecurity2026/topic1000/section2_1.png": 526,
	"./cybersecurity2026/topic1000/section3_1.png": 2201,
	"./cybersecurity2026/topic1000/section3_2.png": 2202,
	"./cybersecurity2026/topic1000/section3_bg.png": 2203,
	"./cybersecurity2026/topic1000/section3_bubble.png": 2204,
	"./cybersecurity2026/topic1000/section4_bubble_left.png": 2205,
	"./cybersecurity2026/topic1000/section4_bubble_right.png": 2206,
	"./cybersecurity2026/topic1000/section4_ex.png": 2207,
	"./cybersecurity2026/topic1000/section5_1.png": 2208,
	"./cybersecurity2026/topic1000/tab_bg.png": 2209,
	"./cybersecurity2026/topic1000/tool-pic/tool_item_1.png": 2210,
	"./cybersecurity2026/topic1000/tool-pic/tool_item_1_m.png": 2211,
	"./cybersecurity2026/topic1000/tool-pic/tool_item_2.png": 2212,
	"./cybersecurity2026/topic1000/tool-pic/tool_item_2_m.png": 2213,
	"./cybersecurity2026/topic1000/tool-pic/tool_item_3.png": 2214,
	"./cybersecurity2026/topic1000/tool-pic/tool_item_3_m.png": 2215,
	"./cybersecurity2026/topic1000/tool-pic/tool_item_4.png": 2216,
	"./cybersecurity2026/topic1000/tool-pic/tool_item_4_m.png": 2217,
	"./cybersecurity2026/topic1000/tool_bubble.png": 2218,
	"./cybersecurity2026/topic1000/tools-bj-bottom.png": 527,
	"./cybersecurity2026/topic1000/tools-bj-top.png": 528,
	"./cybersecurity2026/topic1000/use/m_use_action_back_cz.png": 2219,
	"./cybersecurity2026/topic1000/use/m_use_action_back_hk.png": 2220,
	"./cybersecurity2026/topic1000/use/m_use_action_back_xw.png": 2221,
	"./cybersecurity2026/topic1000/use/m_use_action_back_zc.png": 2222,
	"./cybersecurity2026/topic1000/use/m_use_action_cz.png": 2223,
	"./cybersecurity2026/topic1000/use/m_use_action_hk.png": 2224,
	"./cybersecurity2026/topic1000/use/m_use_action_xw.png": 2225,
	"./cybersecurity2026/topic1000/use/m_use_action_zc.png": 2226,
	"./cybersecurity2026/topic1000/use/use_action_back_cz.png": 2227,
	"./cybersecurity2026/topic1000/use/use_action_back_hk.png": 2228,
	"./cybersecurity2026/topic1000/use/use_action_back_xw.png": 2229,
	"./cybersecurity2026/topic1000/use/use_action_back_zc.png": 2230,
	"./cybersecurity2026/topic1000/use/use_action_cz.png": 2231,
	"./cybersecurity2026/topic1000/use/use_action_hk.png": 2232,
	"./cybersecurity2026/topic1000/use/use_action_xw.png": 2233,
	"./cybersecurity2026/topic1000/use/use_action_zc.png": 2234,
	"./cybersecurity2026/topic1000/visit/header_bg.png": 2235,
	"./cybersecurity2026/topic1000/visit/icon1.png": 529,
	"./cybersecurity2026/topic1000/visit/icon2.png": 530,
	"./cybersecurity2026/topic1000/visit/icon3.png": 531,
	"./cybersecurity2026/topic1000/visit/img.png": 532,
	"./cybersecurity2026/topic1000/visit/img_1.png": 533,
	"./cybersecurity2026/topic1000/visit/img_2.png": 534,
	"./cybersecurity2026/topic1000/visit/img_3.png": 535,
	"./cybersecurity2026/topic1000/visit/img_4.png": 536,
	"./cybersecurity2026/topic1000/visit/img_5.png": 537,
	"./cybersecurity2026/topic1000/visit/img_6.png": 538,
	"./cybersecurity2026/topic1000/welcome_bg.png": 2236,
	"./cybersecurity2026/topic1000/welcome_bg_m.png": 2237,
	"./cybersecurity2026/topic1230pm/bg0.png": 2238,
	"./cybersecurity2026/topic1230pm/bg1.png": 2239,
	"./cybersecurity2026/topic1230pm/bg2.png": 2240,
	"./cybersecurity2026/topic1230pm/bg3.png": 2241,
	"./cybersecurity2026/topic1230pm/bg4.png": 2242,
	"./cybersecurity2026/topic1230pm/bg5.png": 2243,
	"./cybersecurity2026/topic1230pm/bg6.png": 2244,
	"./cybersecurity2026/topic1230pm/bg7.png": 2245,
	"./cybersecurity2026/topic1230pm/bg8.png": 2246,
	"./cybersecurity2026/topic1230pm/bg9.png": 2247,
	"./cybersecurity2026/topic1230pm/dialogue-left.png": 2248,
	"./cybersecurity2026/topic1230pm/dialogue-right.png": 2249,
	"./cybersecurity2026/topic1230pm/question.png": 2250,
	"./cybersecurity2026/topic1230pm/section0-img1.png": 539,
	"./cybersecurity2026/topic1230pm/section0-img2.png": 540,
	"./cybersecurity2026/topic1230pm/section1-bg1-h5.png": 2251,
	"./cybersecurity2026/topic1230pm/section1-bg1.png": 2252,
	"./cybersecurity2026/topic1230pm/section1-bg2-h5.png": 2253,
	"./cybersecurity2026/topic1230pm/section1-bg2.png": 2254,
	"./cybersecurity2026/topic1230pm/section1-bg3.png": 2255,
	"./cybersecurity2026/topic1230pm/section1-bg4.png": 2256,
	"./cybersecurity2026/topic1230pm/section1-img1.png": 2257,
	"./cybersecurity2026/topic1230pm/section1-img2.png": 2258,
	"./cybersecurity2026/topic1230pm/section1-item-1-h5.png": 2259,
	"./cybersecurity2026/topic1230pm/section1-item-1.png": 2260,
	"./cybersecurity2026/topic1230pm/section1-item-2-h5.png": 2261,
	"./cybersecurity2026/topic1230pm/section1-item-2.png": 2262,
	"./cybersecurity2026/topic1230pm/section1-item-3-h5.png": 2263,
	"./cybersecurity2026/topic1230pm/section1-item-3.png": 2264,
	"./cybersecurity2026/topic1230pm/section1-item-4-h5.png": 2265,
	"./cybersecurity2026/topic1230pm/section1-item-4.png": 2266,
	"./cybersecurity2026/topic1230pm/section2-bg.png": 2267,
	"./cybersecurity2026/topic1230pm/section2-bg1-h5.png": 2268,
	"./cybersecurity2026/topic1230pm/section2-bg1.png": 2269,
	"./cybersecurity2026/topic1230pm/section2-bg2-h5.png": 2270,
	"./cybersecurity2026/topic1230pm/section2-bg2.png": 2271,
	"./cybersecurity2026/topic1230pm/section2-bg3-h5.png": 2272,
	"./cybersecurity2026/topic1230pm/section2-bg3.png": 2273,
	"./cybersecurity2026/topic1230pm/section2-bg4-h5.png": 2274,
	"./cybersecurity2026/topic1230pm/section2-bg4.png": 2275,
	"./cybersecurity2026/topic1230pm/section2-bg5.png": 2276,
	"./cybersecurity2026/topic1230pm/section2-bg6.png": 2277,
	"./cybersecurity2026/topic1230pm/section2-guide-bar-h5.png": 2278,
	"./cybersecurity2026/topic1230pm/section2-guide-bar.png": 2279,
	"./cybersecurity2026/topic1230pm/section2-pic1.png": 541,
	"./cybersecurity2026/topic1230pm/section2-pic2.png": 542,
	"./cybersecurity2026/topic1230pm/section3-img1.png": 543,
	"./cybersecurity2026/topic1230pm/section3-img2.png": 544,
	"./cybersecurity2026/topic1230pm/section3-img3.png": 545,
	"./cybersecurity2026/topic1230pm/section3-num1.png": 546,
	"./cybersecurity2026/topic1230pm/section3-num2.png": 547,
	"./cybersecurity2026/topic1230pm/section3-num3.png": 548,
	"./cybersecurity2026/topic1230pm/section3-num4.png": 549,
	"./cybersecurity2026/topic1230pm/section3-num5.png": 550,
	"./cybersecurity2026/topic1230pm/section3-pic2.png": 551,
	"./cybersecurity2026/topic1230pm/section3-pic3.png": 2280,
	"./cybersecurity2026/topic1230pm/section3-pic4.png": 2281,
	"./cybersecurity2026/topic1230pm/section3-pic5.png": 2282,
	"./cybersecurity2026/topic1230pm/section3-pic6-h5.png": 2283,
	"./cybersecurity2026/topic1230pm/section3-pic6.png": 2284,
	"./cybersecurity2026/topic1230pm/section3-pic7.png": 2285,
	"./cybersecurity2026/topic1230pm/section3-pic8.png": 2286,
	"./cybersecurity2026/topic1230pm/section4-pic1.png": 2287,
	"./cybersecurity2026/topic1230pm/section4-pic2.png": 2288,
	"./cybersecurity2026/topic1230pm/section4-pic3.png": 552,
	"./cybersecurity2026/topic1230pm/section5-pic1-h5.png": 2289,
	"./cybersecurity2026/topic1230pm/section5-pic1.png": 2290,
	"./cybersecurity2026/topic1230pm/section5-pic2.png": 2291,
	"./cybersecurity2026/topic1230pm/section5-pic3.png": 2292,
	"./cybersecurity2026/topic1600/attentions/icon1.png": 553,
	"./cybersecurity2026/topic1600/attentions/icon2.png": 554,
	"./cybersecurity2026/topic1600/attentions/icon3.png": 555,
	"./cybersecurity2026/topic1600/attentions/icon4.png": 556,
	"./cybersecurity2026/topic1600/bg1.png": 2293,
	"./cybersecurity2026/topic1600/bg2.png": 2294,
	"./cybersecurity2026/topic1600/bg3.png": 2295,
	"./cybersecurity2026/topic1600/bg4.png": 2296,
	"./cybersecurity2026/topic1600/bg5.png": 2297,
	"./cybersecurity2026/topic1600/bg6.png": 2298,
	"./cybersecurity2026/topic1600/bg7.png": 2299,
	"./cybersecurity2026/topic1600/bg8.png": 2300,
	"./cybersecurity2026/topic1600/bg9.png": 2301,
	"./cybersecurity2026/topic1600/data-analysis.png": 557,
	"./cybersecurity2026/topic1600/guide_bg.png": 2302,
	"./cybersecurity2026/topic1600/guide_bg_top.png": 2303,
	"./cybersecurity2026/topic1600/link_1.png": 558,
	"./cybersecurity2026/topic1600/link_2.png": 559,
	"./cybersecurity2026/topic1600/link_3.png": 560,
	"./cybersecurity2026/topic1600/link_pic.png": 561,
	"./cybersecurity2026/topic1600/m_guide_bg_bottom.png": 2304,
	"./cybersecurity2026/topic1600/m_guide_bg_top.png": 2305,
	"./cybersecurity2026/topic1600/person.png": 562,
	"./cybersecurity2026/topic1600/quiz_bg.png": 2306,
	"./cybersecurity2026/topic1600/regression_bottom.png": 563,
	"./cybersecurity2026/topic1600/regression_top.png": 564,
	"./cybersecurity2026/topic1600/risk/img.png": 287,
	"./cybersecurity2026/topic1600/risk/img_1.png": 288,
	"./cybersecurity2026/topic1600/risk/img_2.png": 289,
	"./cybersecurity2026/topic1600/risk/img_3.png": 290,
	"./cybersecurity2026/topic1600/risk/img_4.png": 291,
	"./cybersecurity2026/topic1600/risk/img_5.png": 292,
	"./cybersecurity2026/topic1600/section1-bg-left.png": 2307,
	"./cybersecurity2026/topic1600/section1-bubble.png": 2308,
	"./cybersecurity2026/topic1600/section1_1.png": 565,
	"./cybersecurity2026/topic1600/section1_bubble.png": 2309,
	"./cybersecurity2026/topic1600/tools-bottom.png": 566,
	"./cybersecurity2026/topic1600/tools-top.png": 567,
	"./cybersecurity2026/topic1600/top-box-img.png": 568,
	"./cybersecurity2026/topic1600/trend-bubble.png": 2310,
	"./cybersecurity2026/topic1600/trend-top.png": 569,
	"./cybersecurity2026/topic1600/use/m_use_action_back1.png": 2311,
	"./cybersecurity2026/topic1600/use/m_use_action_back2.png": 2312,
	"./cybersecurity2026/topic1600/use/m_use_action_back3.png": 2313,
	"./cybersecurity2026/topic1600/use/m_use_action_back4.png": 2314,
	"./cybersecurity2026/topic1600/use/use_action_back1.png": 2315,
	"./cybersecurity2026/topic1600/use/use_action_back2.png": 2316,
	"./cybersecurity2026/topic1600/use/use_action_back3.png": 2317,
	"./cybersecurity2026/topic1600/use/use_action_back4.png": 2318,
	"./cybersecurity2026/topic900/background1.png": 2319,
	"./cybersecurity2026/topic900/background2.png": 2320,
	"./cybersecurity2026/topic900/background3.png": 2321,
	"./cybersecurity2026/topic900/background4.png": 2322,
	"./cybersecurity2026/topic900/bg-h5.png": 2323,
	"./cybersecurity2026/topic900/bubble-orange.png": 2324,
	"./cybersecurity2026/topic900/chatBg-h5.png": 2325,
	"./cybersecurity2026/topic900/chatBg.png": 2326,
	"./cybersecurity2026/topic900/section1-bg.png": 2327,
	"./cybersecurity2026/topic900/section1-header-Alert.png": 570,
	"./cybersecurity2026/topic900/section1-header-Edit.png": 571,
	"./cybersecurity2026/topic900/section1-header-Eye-off.png": 572,
	"./cybersecurity2026/topic900/section1-header-Hard-drive.png": 573,
	"./cybersecurity2026/topic900/section1-header-btn.png": 2328,
	"./cybersecurity2026/topic900/section1-header.png": 2329,
	"./cybersecurity2026/topic900/section1-img3.png": 2330,
	"./cybersecurity2026/topic900/section1-img4.png": 574,
	"./cybersecurity2026/topic900/section3-bg.png": 2331,
	"./cybersecurity2026/topic900/section3-icon1.png": 575,
	"./cybersecurity2026/topic900/section3-icon2.png": 576,
	"./cybersecurity2026/topic900/section3-img2.png": 577,
	"./cybersecurity2026/topic900/section4-bg.png": 2332,
	"./cybersecurity2026/topic900/section4-bg2-h5.png": 2333,
	"./cybersecurity2026/topic900/section4-bg2.png": 2334,
	"./cybersecurity2026/topic900/section4-pic1.png": 2335,
	"./cybersecurity2026/topic900/talk-down.png": 2336,
	"./cybersecurity2026/topic900/talk-up.png": 2337,
	"./cybersecurity2026/topic900/topic900_bg1.png": 578,
	"./cybersecurity2026/topic900/topic900_bg2.png": 579,
	"./cybersecurity2026/welcome/bubble.png": 2338,
	"./cybersecurity2026/welcome/folder.png": 2339,
	"./cybersecurity2026/welcome/four.png": 580,
	"./cybersecurity2026/welcome/highway.png": 2340,
	"./cybersecurity2026/welcome/line.png": 581,
	"./cybersecurity2026/welcome/m_highway.png": 2341,
	"./cybersecurity2026/welcome/m_welcome_bg.png": 2342,
	"./cybersecurity2026/welcome/person.png": 2343,
	"./cybersecurity2026/welcome/record.png": 2344,
	"./cybersecurity2026/welcome/three.png": 582,
	"./cybersecurity2026/welcome/triangle.png": 583,
	"./cybersecurity2026/welcome/two.png": 584,
	"./cybersecurity2026/welcome/welcome_bg.png": 2345,
	"./dataLeakage.png": 2346,
	"./dataLeakageRealcase-en.jpg": 1098,
	"./dataLeakageRealcase-mobile-en.jpg": 1099,
	"./dataLeakageRealcase-mobile.jpg": 1100,
	"./dataLeakageRealcase.jpg": 1101,
	"./desk-clean-icon1.png": 2347,
	"./desk-clean-icon2.png": 2348,
	"./desk-clean-icon3.png": 2349,
	"./desk-clean-icon4.png": 2350,
	"./desk-clean-img1.png": 2351,
	"./desk-clean-img2.png": 2352,
	"./desk-clean-img3.png": 2353,
	"./desk-clean-img4.png": 2354,
	"./desk-clean1.png": 2355,
	"./desk-clean2.png": 2356,
	"./desk-clean3.png": 2357,
	"./desk-clean4.png": 2358,
	"./desk-clean5.png": 2359,
	"./education/close_icon.png": 293,
	"./education/cybersecurity/arrow-right-circle.png": 585,
	"./education/cybersecurity/bg-light.png": 2360,
	"./education/cybersecurity/bg1.png": 2361,
	"./education/cybersecurity/bg2.png": 2362,
	"./education/cybersecurity/bg3.png": 2363,
	"./education/cybersecurity/bg4.png": 2364,
	"./education/cybersecurity/bg5.png": 2365,
	"./education/cybersecurity/bg6.png": 2366,
	"./education/cybersecurity/bg7.png": 2367,
	"./education/cybersecurity/chat-bg-h5.png": 2368,
	"./education/cybersecurity/chat-bg-pc.png": 2369,
	"./education/cybersecurity/chatBg.png": 2370,
	"./education/cybersecurity/h5-bg/case-study-center.png": 2371,
	"./education/cybersecurity/h5-bg/case-study-left.png": 2372,
	"./education/cybersecurity/h5-bg/case-study-right.png": 2373,
	"./education/cybersecurity/h5-bg/case-study-tips.png": 2374,
	"./education/cybersecurity/h5-bg/h5-bg1.png": 2375,
	"./education/cybersecurity/h5-bg/h5-bg2.png": 2376,
	"./education/cybersecurity/h5-bg/h5-bg3.png": 2377,
	"./education/cybersecurity/h5-bg/h5-bg4.png": 2378,
	"./education/cybersecurity/h5-bg/h5-bg5.png": 2379,
	"./education/cybersecurity/h5-bg/h5-bg6.png": 2380,
	"./education/cybersecurity/h5-bg/h5-bg7.png": 2381,
	"./education/cybersecurity/h5-bg/h5-bg8.png": 2382,
	"./education/cybersecurity/h5-bg/h5-pic-bg1.png": 2383,
	"./education/cybersecurity/h5-bg/process-bg.png": 2384,
	"./education/cybersecurity/h5-bg/section-process-1.png": 2385,
	"./education/cybersecurity/h5-bg/section-process-2.png": 2386,
	"./education/cybersecurity/h5-bg/section-process-3.png": 2387,
	"./education/cybersecurity/h5-bg/section-process-4.png": 2388,
	"./education/cybersecurity/icon-award.png": 586,
	"./education/cybersecurity/icon-book-open.png": 587,
	"./education/cybersecurity/icon-cast.png": 588,
	"./education/cybersecurity/icon-chevrons up.png": 589,
	"./education/cybersecurity/icon-clock.png": 590,
	"./education/cybersecurity/icon-command.png": 591,
	"./education/cybersecurity/message-bg.png": 2389,
	"./education/cybersecurity/message-bg.svg": 2390,
	"./education/cybersecurity/num-01.svg": 592,
	"./education/cybersecurity/num-02.svg": 593,
	"./education/cybersecurity/num-03.svg": 594,
	"./education/cybersecurity/num-04.svg": 595,
	"./education/cybersecurity/num-05.svg": 596,
	"./education/cybersecurity/num-icon-bg.png": 597,
	"./education/cybersecurity/num-icon1.svg": 598,
	"./education/cybersecurity/num-icon2.svg": 599,
	"./education/cybersecurity/num-icon3.svg": 600,
	"./education/cybersecurity/num-icon4.svg": 601,
	"./education/cybersecurity/num-icon5.svg": 602,
	"./education/cybersecurity/plan-bg.svg": 2391,
	"./education/cybersecurity/plan-pic-bg-h5.png": 2392,
	"./education/cybersecurity/plan-pic.png": 603,
	"./education/cybersecurity/question-bg.png": 2393,
	"./education/cybersecurity/section-process-bg1.png": 2394,
	"./education/cybersecurity/section-process-bg2.png": 2395,
	"./education/cybersecurity/section-process-bg3.png": 2396,
	"./education/cybersecurity/section-process-bg4.png": 2397,
	"./education/cybersecurity/section0-bg1.png": 604,
	"./education/cybersecurity/section0-bg2.png": 605,
	"./education/cybersecurity/section0-bg3.png": 2398,
	"./education/cybersecurity/section1-bg-h5.png": 2399,
	"./education/cybersecurity/section1-bg1.png": 606,
	"./education/cybersecurity/section1-bg2.svg": 2400,
	"./education/cybersecurity/section1-bg3-h5.png": 2401,
	"./education/cybersecurity/section1-bg3.svg": 2402,
	"./education/cybersecurity/section1-bg4.svg": 2403,
	"./education/cybersecurity/section1-measure1.svg": 2404,
	"./education/cybersecurity/section1-measure2.svg": 2405,
	"./education/cybersecurity/section1-measure3.svg": 2406,
	"./education/cybersecurity/section1-process-bg.png": 2407,
	"./education/cybersecurity/section1-process-bg1.png": 607,
	"./education/cybersecurity/section1-process-bg2.png": 608,
	"./education/cybersecurity/union.png": 2408,
	"./education/error_bg.png": 2409,
	"./education/ot/background-left.png": 2410,
	"./education/ot/bubble_bg.png": 2411,
	"./education/ot/guide_bg.png": 2412,
	"./education/ot/guide_bg_top.png": 2413,
	"./education/ot/guide_bg_y.png": 2414,
	"./education/ot/h5_guide_bg_top.png": 2415,
	"./education/ot/header-bg.png": 2416,
	"./education/ot/icon/icon1.png": 609,
	"./education/ot/icon/icon2.png": 610,
	"./education/ot/icon/icon3.png": 611,
	"./education/ot/icon/icon4.png": 612,
	"./education/ot/icon/icon5.png": 613,
	"./education/ot/icon/icon6.png": 614,
	"./education/ot/m_background-left.png": 2417,
	"./education/ot/ot_quiz_bg.png": 2418,
	"./education/ot/person.png": 615,
	"./education/ot/picture/img1.png": 616,
	"./education/ot/picture/img2.png": 617,
	"./education/ot/picture/img3.png": 618,
	"./education/ot/picture/img4.png": 619,
	"./education/ot/picture/img5.png": 620,
	"./education/ot/picture/img6.png": 621,
	"./education/ot/section0_bg.png": 2419,
	"./education/ot/section1_bg.png": 2420,
	"./education/ot/section2_bg.png": 2421,
	"./education/ot/section2_bg_1.png": 2422,
	"./education/ot/section2_bg_2.png": 2423,
	"./education/ot/tools-bj-bottom.png": 2424,
	"./education/ot/tools-bj-top.png": 2425,
	"./education/ot/welcome_bg_bubble.png": 2426,
	"./education/ptm/ai-bg.png": 2427,
	"./education/ptm/ai_left_bg.png": 622,
	"./education/ptm/ai_right_bg.png": 623,
	"./education/ptm/bubble/bubble1.png": 2428,
	"./education/ptm/bubble/bubble3.png": 2429,
	"./education/ptm/bubble/bubble4.png": 2430,
	"./education/ptm/bubble/bubble6.png": 2431,
	"./education/ptm/bubble/m_bubble1.png": 2432,
	"./education/ptm/bubble/m_bubble3.png": 2433,
	"./education/ptm/bubble/m_bubble4.png": 2434,
	"./education/ptm/bubble/m_bubble6.png": 2435,
	"./education/ptm/bubble_bg.png": 2436,
	"./education/ptm/factor/factor_bubble.png": 2437,
	"./education/ptm/factor/factor_item_1.png": 2438,
	"./education/ptm/factor/factor_item_2.png": 2439,
	"./education/ptm/factor/factor_item_3.png": 2440,
	"./education/ptm/factor/factor_item_4.png": 2441,
	"./education/ptm/factor/m_factor_item_1.png": 2442,
	"./education/ptm/factor/m_factor_item_2.png": 2443,
	"./education/ptm/factor/m_factor_item_3.png": 2444,
	"./education/ptm/factor/m_factor_item_4.png": 2445,
	"./education/ptm/factor_left_bg.png": 2446,
	"./education/ptm/factor_right_bg.png": 624,
	"./education/ptm/light.png": 294,
	"./education/ptm/m_ai_bg.png": 2447,
	"./education/ptm/m_bubble_bg.png": 2448,
	"./education/ptm/m_ptm_bg_2.png": 2449,
	"./education/ptm/m_welcome_bg_bubble.png": 2450,
	"./education/ptm/person.png": 625,
	"./education/ptm/practice_left_bg.png": 626,
	"./education/ptm/practice_right_bg.png": 627,
	"./education/ptm/practice_top_bg.png": 628,
	"./education/ptm/ptm_bg_1.png": 2451,
	"./education/ptm/ptm_bg_2.png": 2452,
	"./education/ptm/ptm_quiz_bg.png": 2453,
	"./education/ptm/q_right_bg.png": 629,
	"./education/ptm/use/m_use_action_back_cz.png": 2454,
	"./education/ptm/use/m_use_action_back_hk.png": 2455,
	"./education/ptm/use/m_use_action_back_xw.png": 2456,
	"./education/ptm/use/m_use_action_back_zc.png": 2457,
	"./education/ptm/use/m_use_action_cz.png": 2458,
	"./education/ptm/use/m_use_action_hk.png": 2459,
	"./education/ptm/use/m_use_action_xw.png": 2460,
	"./education/ptm/use/m_use_action_zc.png": 2461,
	"./education/ptm/use/use_action_back_cz.png": 2462,
	"./education/ptm/use/use_action_back_hk.png": 2463,
	"./education/ptm/use/use_action_back_xw.png": 2464,
	"./education/ptm/use/use_action_back_zc.png": 2465,
	"./education/ptm/use/use_action_cz.png": 2466,
	"./education/ptm/use/use_action_hk.png": 2467,
	"./education/ptm/use/use_action_xw.png": 2468,
	"./education/ptm/use/use_action_zc.png": 2469,
	"./education/ptm/welcome_bg.png": 2470,
	"./education/ptm/welcome_bg_bottom.png": 2471,
	"./education/ptm/welcome_bg_bubble.png": 2472,
	"./education/quiz/again_icon.png": 156,
	"./education/quiz/answer_left.png": 295,
	"./education/quiz/correct_icon.png": 630,
	"./education/quiz/downward_icon.png": 157,
	"./education/quiz/error_icon.png": 631,
	"./education/quiz/m_quiz_bg.png": 2473,
	"./education/quiz/m_quiz_bg_1.png": 2474,
	"./education/quiz/m_review_top_bg.png": 2475,
	"./education/quiz/no_pass_bg.png": 2476,
	"./education/quiz/no_pass_person.png": 158,
	"./education/quiz/no_pass_word_bg.png": 2477,
	"./education/quiz/pass_bg.png": 2478,
	"./education/quiz/pass_download.png": 159,
	"./education/quiz/pass_person.png": 160,
	"./education/quiz/pass_word_bg.png": 2479,
	"./education/quiz/quiz_bg.png": 2480,
	"./education/quiz/quiz_bg_1.png": 2481,
	"./education/quiz/review_bg.png": 2482,
	"./education/quiz/review_top_bg.png": 2483,
	"./education/quiz/smile.png": 632,
	"./education/quiz/upset.png": 633,
	"./education/quiz_bg.png": 2484,
	"./education/quiz_mask.png": 2485,
	"./education/right_bg.png": 2486,
	"./education/topic1000/Interacting1.png": 634,
	"./education/topic1000/Interacting2.png": 635,
	"./education/topic1000/arrow.svg": 2487,
	"./education/topic1000/bg1.png": 2488,
	"./education/topic1000/bg2.png": 2489,
	"./education/topic1000/bg3.png": 2490,
	"./education/topic1000/bg4.png": 2491,
	"./education/topic1000/bubble/bubble1.png": 2492,
	"./education/topic1000/bubble/bubble3.png": 2493,
	"./education/topic1000/bubble/bubble4.png": 2494,
	"./education/topic1000/bubble/bubble6.png": 2495,
	"./education/topic1000/case-study-h5.png": 2496,
	"./education/topic1000/h5-bg/collapse-bg.png": 2497,
	"./education/topic1000/h5-bg/h5-section2-bg1.png": 2498,
	"./education/topic1000/h5-bg/h5-section2-bg2.png": 2499,
	"./education/topic1000/h5-bg/h5-section2-bg3.png": 2500,
	"./education/topic1000/h5-bg/h5-section2-bg4.png": 2501,
	"./education/topic1000/link1-1.png": 636,
	"./education/topic1000/link1.png": 637,
	"./education/topic1000/link2.png": 638,
	"./education/topic1000/link3.png": 639,
	"./education/topic1000/panelData1.png": 640,
	"./education/topic1000/panelData2.png": 641,
	"./education/topic1000/panelData3.png": 642,
	"./education/topic1000/panelData4.jpg": 386,
	"./education/topic1000/panelData5.png": 643,
	"./education/topic1000/panelData6.jpg": 387,
	"./education/topic1000/phishing/bg.svg": 2502,
	"./education/topic1000/phishing/bubble_bg.svg": 644,
	"./education/topic1000/phishing/chatBg.png": 2503,
	"./education/topic1000/phishing/chatBg2.png": 2504,
	"./education/topic1000/phishing/icon1.svg": 645,
	"./education/topic1000/phishing/icon2.svg": 646,
	"./education/topic1000/phishing/icon3.svg": 647,
	"./education/topic1000/phishing/icon4.svg": 648,
	"./education/topic1000/phishing/icon5.svg": 649,
	"./education/topic1000/phishing/icon6.svg": 650,
	"./education/topic1000/phishing/pic1.svg": 2505,
	"./education/topic1000/phishing/questionBg.png": 2506,
	"./education/topic1000/phishing/tab1.svg": 2507,
	"./education/topic1000/phishing/tab2.svg": 2508,
	"./education/topic1000/phishing/title_bg.svg": 2509,
	"./education/topic1000/seciton3_icon.svg": 2510,
	"./education/topic1000/section1_footer_bg.png": 651,
	"./education/topic1000/section1_tool.png": 2511,
	"./education/topic1000/section1_tool1.png": 2512,
	"./education/topic1000/section1_tool_bubble.svg": 2513,
	"./education/topic1000/section3-bg-left.png": 2514,
	"./education/topic1000/section3_bg2.svg": 652,
	"./education/topic1000/section3_bg3.png": 653,
	"./education/topic1000/section3_bg4.png": 2515,
	"./education/topic1000/section3_bg5.png": 2516,
	"./education/topic1000/step-h5-bg.png": 2517,
	"./education/topic1000/tool-pic/tool-item-h5-bg1.png": 2518,
	"./education/topic1000/tool-pic/tool-item-h5-bg2.png": 2519,
	"./education/topic1000/tool-pic/tool-item-h5-bg3.png": 2520,
	"./education/topic1000/tool-pic/tool-item-h5-bg4.png": 2521,
	"./education/topic1000/tool-pic/tool-item-h5-blue-bg1.png": 2522,
	"./education/topic1000/tool-pic/tool-item-h5-blue-bg2.png": 2523,
	"./education/topic1000/tool-pic/tool-item-h5-blue-bg3.png": 2524,
	"./education/topic1000/tool-pic/tool-item-h5-blue-bg4.png": 2525,
	"./education/topic1000/tool-pic/tool_bubble.png": 2526,
	"./education/topic1000/tool-pic/tool_bubble_blue.png": 2527,
	"./education/topic1000/tool-pic/tool_item_1.png": 2528,
	"./education/topic1000/tool-pic/tool_item_2.png": 2529,
	"./education/topic1000/tool-pic/tool_item_3.png": 2530,
	"./education/topic1000/tool-pic/tool_item_4.png": 2531,
	"./education/topic1000/tool-pic/tool_item_blue1.png": 2532,
	"./education/topic1000/tool-pic/tool_item_blue2.png": 2533,
	"./education/topic1000/tool-pic/tool_item_blue3.png": 2534,
	"./education/topic1000/tool-pic/tool_item_blue4.png": 2535,
	"./education/topic900/bg-light.png": 2536,
	"./education/topic900/bg-orange.png": 2537,
	"./education/topic900/bg-priority.png": 2538,
	"./education/topic900/bg-white.png": 2539,
	"./education/topic900/bg1.png": 2540,
	"./education/topic900/bg2.png": 2541,
	"./education/topic900/bg3.png": 2542,
	"./education/topic900/bg4.png": 2543,
	"./education/topic900/chatBg.png": 2544,
	"./education/topic900/cyber-policy-bg.png": 2545,
	"./education/topic900/h5-bg/h5-section1-bg1.png": 2546,
	"./education/topic900/h5-bg/h5-section1-bg2.png": 2547,
	"./education/topic900/h5-bg/h5-section1-bg3.png": 2548,
	"./education/topic900/h5-bg/h5-section1-bg4.png": 2549,
	"./education/topic900/h5-bg/h5-section1-bg5.png": 2550,
	"./education/topic900/h5-bg/h5-section1-bg6.png": 2551,
	"./education/topic900/h5-bg/h5-section1-pic1.png": 2552,
	"./education/topic900/h5-bg/h5-section1-step.png": 2553,
	"./education/topic900/h5-bg/h5-section1-tip1.png": 2554,
	"./education/topic900/ot_quiz_bg.png": 2555,
	"./education/topic900/person.svg": 654,
	"./education/topic900/priority.png": 2556,
	"./education/topic900/priority_icon1.png": 296,
	"./education/topic900/priority_icon2.png": 297,
	"./education/topic900/priority_icon3.svg": 298,
	"./education/topic900/right-circle.png": 400,
	"./education/topic900/section1_1.png": 299,
	"./education/topic900/section1_2.png": 2557,
	"./education/topic900/section2_1.svg": 655,
	"./education/topic900/section2_2.png": 2558,
	"./education/topic900/section2_3.svg": 2559,
	"./education/topic900/section3_bg.svg": 2560,
	"./education/topic900/step.png": 2561,
	"./education/topic900/step1.png": 2562,
	"./education/topic900/step1.svg": 2563,
	"./education/topic900/step11.png": 656,
	"./education/topic900/step2.png": 2564,
	"./education/topic900/step2.svg": 2565,
	"./education/topic900/step22.png": 657,
	"./education/topic900/step3.png": 658,
	"./education/topic900/step3.svg": 2566,
	"./education/topic900/step4.png": 659,
	"./education/topic900/topic900_bg1.png": 660,
	"./education/topic900/topic900_bg2.png": 661,
	"./education/topic900/topic900_tip.svg": 2567,
	"./education/welcome/five.png": 662,
	"./education/welcome/folder.png": 2568,
	"./education/welcome/four.png": 663,
	"./education/welcome/highway.png": 2569,
	"./education/welcome/line.png": 664,
	"./education/welcome/m_five.png": 665,
	"./education/welcome/m_four.png": 666,
	"./education/welcome/m_highway.png": 2570,
	"./education/welcome/m_two.png": 667,
	"./education/welcome/m_welcome_bg.png": 2571,
	"./education/welcome/one.png": 668,
	"./education/welcome/person.png": 2572,
	"./education/welcome/record.png": 2573,
	"./education/welcome/three.png": 669,
	"./education/welcome/two.png": 670,
	"./education/welcome/vase.png": 2574,
	"./education/welcome/welcome_bg.png": 2575,
	"./equal-highlight.png": 671,
	"./equal.png": 672,
	"./filterArrow.svg": 300,
	"./finance-gif1.gif": 2576,
	"./finance-gif2.gif": 2577,
	"./finance-gif3.gif": 2578,
	"./finance-gif4.gif": 2579,
	"./finance-topic1.png": 2580,
	"./finance-topic2.png": 2581,
	"./finance-topic3.png": 2582,
	"./finance-topic4.png": 2583,
	"./finance/close_icon.png": 673,
	"./finance/error_bg.png": 2584,
	"./finance/img.png": 2585,
	"./finance/quiz/answer_left.png": 674,
	"./finance/quiz/correct_icon.png": 675,
	"./finance/quiz/error_icon.png": 676,
	"./finance/quiz/m_quiz_bg.png": 2586,
	"./finance/quiz/m_quiz_bg_1.png": 2587,
	"./finance/quiz/m_review_bg.png": 2588,
	"./finance/quiz/m_review_top_bg.png": 2589,
	"./finance/quiz/no_pass_bg.png": 2590,
	"./finance/quiz/no_pass_word_bg.png": 2591,
	"./finance/quiz/pass_bg.png": 2592,
	"./finance/quiz/pass_word_bg.png": 2593,
	"./finance/quiz/quiz_bg.png": 2594,
	"./finance/quiz/quiz_bg_1.png": 2595,
	"./finance/quiz/review_bg.png": 2596,
	"./finance/quiz/review_top_bg.png": 2597,
	"./finance/quiz/smile.png": 677,
	"./finance/quiz/upset.png": 678,
	"./finance/quiz_bg.png": 2598,
	"./finance/right_bg.png": 2599,
	"./finance/topic1100am/bg1.png": 2600,
	"./finance/topic1100am/bg2.png": 2601,
	"./finance/topic1100am/bg3.png": 2602,
	"./finance/topic1100am/bg4.png": 2603,
	"./finance/topic1100am/bg5.png": 2604,
	"./finance/topic1100am/bg6.png": 2605,
	"./finance/topic1100am/quiz_bg.png": 2606,
	"./finance/topic1100am/section1-arrow-down-circle.png": 679,
	"./finance/topic1100am/section1-bg-chat.png": 2607,
	"./finance/topic1100am/section1-bg.png": 680,
	"./finance/topic1100am/section1-bg1.png": 2608,
	"./finance/topic1100am/section1-img1.png": 681,
	"./finance/topic1100am/section1-img2.png": 682,
	"./finance/topic1100am/section1-img3.png": 683,
	"./finance/topic1100am/section1-img4.png": 684,
	"./finance/topic1100am/section1-img5.png": 685,
	"./finance/topic1100am/section2-2-img1.png": 686,
	"./finance/topic1100am/section2-3-img1.png": 2609,
	"./finance/topic1100am/section2-3-img2.png": 2610,
	"./finance/topic1100am/section2-4-img1.png": 2611,
	"./finance/topic1100am/section2-4-img2.png": 687,
	"./finance/topic1100am/section2-5-img1.png": 688,
	"./finance/topic1100am/section2-6-img1.png": 689,
	"./finance/topic1100am/section2-7-h5-num1.png": 2612,
	"./finance/topic1100am/section2-7-h5-num2.png": 2613,
	"./finance/topic1100am/section2-7-h5-num3.png": 2614,
	"./finance/topic1100am/section2-7-h5-num4.png": 2615,
	"./finance/topic1100am/section2-7-img1.png": 2616,
	"./finance/topic1100am/section2-7-num1.png": 2617,
	"./finance/topic1100am/section2-7-num2.png": 2618,
	"./finance/topic1100am/section2-7-num3.png": 2619,
	"./finance/topic1100am/section2-7-num4.png": 2620,
	"./finance/topic1100am/section2-icon1.png": 690,
	"./finance/topic1100am/section2-icon2.png": 691,
	"./finance/topic1100am/section2-icon3.png": 692,
	"./finance/topic1100am/section2-icon4.png": 693,
	"./finance/topic1100am/section2-icon5.png": 694,
	"./finance/topic1100am/section2-img1.png": 695,
	"./finance/topic1100am/section2-img2.png": 696,
	"./finance/topic1100am/topic0-bg0.png": 2621,
	"./finance/topic1100am/topic0-bg1.png": 697,
	"./finance/topic1100am/topic0-bg3.png": 698,
	"./finance/topic1100am/topic0-dialog.png": 2622,
	"./finance/topic1400/bg0_m.png": 2623,
	"./finance/topic1400/bg1.png": 2624,
	"./finance/topic1400/bg1_m.png": 2625,
	"./finance/topic1400/bg2.png": 2626,
	"./finance/topic1400/bg2_m.png": 2627,
	"./finance/topic1400/bg3.png": 2628,
	"./finance/topic1400/bg3_m.png": 2629,
	"./finance/topic1400/bg4.png": 2630,
	"./finance/topic1400/bg4_1_m.png": 2631,
	"./finance/topic1400/bg4_m.png": 2632,
	"./finance/topic1400/bg5.png": 2633,
	"./finance/topic1400/bg5_m.png": 2634,
	"./finance/topic1400/bubble.png": 2635,
	"./finance/topic1400/bubble_1_left.png": 2636,
	"./finance/topic1400/bubble_1_right.png": 2637,
	"./finance/topic1400/cycle_img.png": 2638,
	"./finance/topic1400/factor/section1-bg4.png": 2639,
	"./finance/topic1400/factor/section1-img2.png": 2640,
	"./finance/topic1400/importance/chatBg.png": 2641,
	"./finance/topic1400/importance/code1.png": 401,
	"./finance/topic1400/importance/code2.png": 699,
	"./finance/topic1400/importance/code3.png": 700,
	"./finance/topic1400/importance/code4.png": 701,
	"./finance/topic1400/importance/person.png": 702,
	"./finance/topic1400/m_section1-bg3.png": 2642,
	"./finance/topic1400/m_section5-pic1.png": 2643,
	"./finance/topic1400/person.png": 703,
	"./finance/topic1400/q_right_bg.png": 704,
	"./finance/topic1400/question.png": 2644,
	"./finance/topic1400/section1-bg3.png": 2645,
	"./finance/topic1400/section1-bg4.png": 2646,
	"./finance/topic1400/section1_1.png": 705,
	"./finance/topic1400/section1_bubble.png": 2647,
	"./finance/topic1400/section2-bg.png": 2648,
	"./finance/topic1400/section2-guide-bar-h5.png": 2649,
	"./finance/topic1400/section2-guide-bar.png": 2650,
	"./finance/topic1400/section2-img2.png": 2651,
	"./finance/topic1400/section5-pic1.png": 2652,
	"./finance/topic1400/tampering/code1.png": 402,
	"./finance/topic1400/tampering/code2.png": 706,
	"./finance/topic1400/tampering/code3.png": 707,
	"./finance/topic1400/tampering/code4.png": 708,
	"./finance/topic1600/bg1.png": 2653,
	"./finance/topic1600/bg2.png": 2654,
	"./finance/topic1600/bg3.png": 2655,
	"./finance/topic1600/bg4.png": 2656,
	"./finance/topic1600/bg5.png": 2657,
	"./finance/topic1600/bg6.png": 2658,
	"./finance/topic1600/bg7.png": 2659,
	"./finance/topic1600/bg8.png": 2660,
	"./finance/topic1600/icon1.png": 709,
	"./finance/topic1600/icon2.png": 710,
	"./finance/topic1600/icon3.png": 711,
	"./finance/topic1600/icon4.png": 712,
	"./finance/topic1600/icon5.png": 713,
	"./finance/topic1600/question-bg.png": 2661,
	"./finance/topic1600/section0-bg1.png": 714,
	"./finance/topic1600/section0-bg2.png": 715,
	"./finance/topic1600/section0-h5-bg1.png": 2662,
	"./finance/topic1600/section1-bg1.png": 716,
	"./finance/topic1600/section1-bg2.png": 717,
	"./finance/topic1600/section1-bg3.png": 718,
	"./finance/topic1600/section1-bg4.png": 719,
	"./finance/topic1600/section1-bg5.png": 2663,
	"./finance/topic1600/section1-bg6.png": 2664,
	"./finance/topic1600/section1-bg7.png": 2665,
	"./finance/topic1600/section1-bg8.png": 720,
	"./finance/topic1600/section1-icon1.png": 721,
	"./finance/topic1600/section1-icon2.png": 722,
	"./finance/topic1600/section1-icon3.png": 723,
	"./finance/topic1600/section1-icon4.png": 724,
	"./finance/topic1600/section1-icon5.png": 725,
	"./finance/topic1600/section2-bg1.png": 2666,
	"./finance/topic1600/section2-bg2.png": 2667,
	"./finance/topic1600/section2-bg5.png": 726,
	"./finance/topic1600/section3-bg1.png": 727,
	"./finance/topic1600/section3-bg2.png": 728,
	"./finance/topic1600/section3-bg3.png": 2668,
	"./finance/topic1600/section3-bg4.png": 2669,
	"./finance/topic1600/section3-icon1.png": 729,
	"./finance/topic1600/section3-icon2.png": 730,
	"./finance/topic1600/section3-icon3.png": 731,
	"./finance/topic1600/section3-icon4.png": 732,
	"./finance/topic1600/section3-icon5.png": 733,
	"./finance/topic1600/section3-icon6.png": 734,
	"./finance/topic900/bg0_m.png": 2670,
	"./finance/topic900/bg1.png": 2671,
	"./finance/topic900/bg1_m.png": 2672,
	"./finance/topic900/bg2.png": 2673,
	"./finance/topic900/bg2_m.png": 2674,
	"./finance/topic900/bg3.png": 2675,
	"./finance/topic900/bg3_1_m.png": 2676,
	"./finance/topic900/bg3_m.png": 2677,
	"./finance/topic900/bg4.png": 2678,
	"./finance/topic900/bg4_1_m.png": 2679,
	"./finance/topic900/bg4_m.png": 2680,
	"./finance/topic900/bg5.png": 2681,
	"./finance/topic900/bg5_m.png": 2682,
	"./finance/topic900/book.png": 301,
	"./finance/topic900/bubble.png": 2683,
	"./finance/topic900/bubble_1_left.png": 2684,
	"./finance/topic900/bubble_1_right.png": 2685,
	"./finance/topic900/chatBg-h5.png": 2686,
	"./finance/topic900/chatBg.png": 2687,
	"./finance/topic900/cycle_img.png": 2688,
	"./finance/topic900/cycle_list_left.png": 2689,
	"./finance/topic900/factor/factor_bubble.png": 2690,
	"./finance/topic900/factor/factor_item_1.png": 2691,
	"./finance/topic900/factor/factor_item_2.png": 2692,
	"./finance/topic900/factor/factor_item_3.png": 2693,
	"./finance/topic900/factor/factor_item_4.png": 2694,
	"./finance/topic900/factor/factor_item_5.png": 2695,
	"./finance/topic900/factor/factor_left_bg.png": 2696,
	"./finance/topic900/factor/m_factor_item_1.png": 2697,
	"./finance/topic900/factor/m_factor_item_2.png": 2698,
	"./finance/topic900/factor/m_factor_item_3.png": 2699,
	"./finance/topic900/factor/m_factor_item_4.png": 2700,
	"./finance/topic900/factor/m_factor_item_5.png": 2701,
	"./finance/topic900/light.png": 302,
	"./finance/topic900/link/link1.png": 403,
	"./finance/topic900/link/link2.png": 735,
	"./finance/topic900/link/link3.png": 736,
	"./finance/topic900/link/link4.png": 737,
	"./finance/topic900/link/play.png": 303,
	"./finance/topic900/m_middle_flow_bubble_bg.png": 2702,
	"./finance/topic900/m_middle_flow_person.png": 2703,
	"./finance/topic900/middle_flow_bubble_bg.png": 2704,
	"./finance/topic900/middle_flow_bubble_list.png": 2705,
	"./finance/topic900/middle_flow_person.png": 2706,
	"./finance/topic900/person.png": 738,
	"./finance/topic900/phishing.png": 739,
	"./finance/topic900/q_right_bg.png": 740,
	"./finance/topic900/quiz_bg.png": 2707,
	"./finance/topic900/section2_1.png": 2708,
	"./finance/topic900/section2_2.png": 2709,
	"./finance/topic900/section2_bubble.png": 2710,
	"./finance/topic900/section2_bubble_m.png": 2711,
	"./finance/topic900/section2_right.png": 741,
	"./finance/topic900/section3-bg.png": 2712,
	"./finance/topic900/section3-icon1.png": 742,
	"./finance/topic900/section3-icon2.png": 743,
	"./finance/topic900/section3_bubble.png": 2713,
	"./finance/topic900/tampering_img_1.png": 744,
	"./finance/topic900/tampering_img_2.png": 745,
	"./finance/topic900/tools-bj-bottom.png": 746,
	"./finance/topic900/tools-bj-top.png": 747,
	"./finance/topic900/use/m_use_action_back_cz.png": 2714,
	"./finance/topic900/use/m_use_action_back_hk.png": 2715,
	"./finance/topic900/use/m_use_action_back_xw.png": 2716,
	"./finance/topic900/use/m_use_action_back_zc.png": 2717,
	"./finance/topic900/use/m_use_action_cz.png": 2718,
	"./finance/topic900/use/m_use_action_hk.png": 2719,
	"./finance/topic900/use/m_use_action_xw.png": 2720,
	"./finance/topic900/use/m_use_action_zc.png": 2721,
	"./finance/topic900/use/use_action_back_cz.png": 2722,
	"./finance/topic900/use/use_action_back_hk.png": 2723,
	"./finance/topic900/use/use_action_back_xw.png": 2724,
	"./finance/topic900/use/use_action_back_zc.png": 2725,
	"./finance/topic900/use/use_action_cz.png": 2726,
	"./finance/topic900/use/use_action_hk.png": 2727,
	"./finance/topic900/use/use_action_xw.png": 2728,
	"./finance/topic900/use/use_action_zc.png": 2729,
	"./finance/topic900/welcome_bg.png": 2730,
	"./finance/welcome/highway.png": 2731,
	"./finance/welcome/line.png": 748,
	"./finance/welcome/m_highway.png": 2732,
	"./finance/welcome/m_welcome_bg.png": 2733,
	"./finance/welcome/person.png": 2734,
	"./finance/welcome/triangle.png": 749,
	"./finance/welcome/welcome_bg.png": 2735,
	"./flame-training.gif": 2736,
	"./fonts/02b3f97a-406d-43cb-885c-ba5233577cad.woff2": 2737,
	"./fonts/08b57253-2e0d-4c12-9c57-107f6c67bc49.woff2": 2738,
	"./fonts/08edde9d-c27b-4731-a27f-d6cd9b01cd06.woff": 2739,
	"./fonts/14d824a2-2a5c-4692-8e30-74f6e177b675.ttf": 2740,
	"./fonts/2025/1635950212302373.otf": 2741,
	"./fonts/2025/SourceHanSansCN-Bold.otf": 2742,
	"./fonts/2025/SourceHanSansCN-Bold.ttf": 2743,
	"./fonts/2025/SourceHanSansCN-ExtraLight.ttf": 2744,
	"./fonts/2025/SourceHanSansCN-Heavy.ttf": 2745,
	"./fonts/2025/SourceHanSansCN-Medium.otf": 2746,
	"./fonts/2025/SourceHanSansCN-Normal.otf": 2747,
	"./fonts/2025/SourceHanSansCN-Regular.otf": 2748,
	"./fonts/2025/SourceHanSansCN-Regular.ttf": 2749,
	"./fonts/22c6282d-e7aa-406b-89dc-5176916a9c44.ttf": 2750,
	"./fonts/240c57a0-fdce-440d-9ce3-85e0cb56f470.woff2": 2751,
	"./fonts/2a34f1f8-d701-4949-b12d-133c1c2636eb.woff": 2752,
	"./fonts/418e7417-47f3-40a1-8817-519a566f9d82.eot": 2753,
	"./fonts/4c21ab66-1566-4a85-b310-fbc649985f88.eot": 2754,
	"./fonts/4cc8f5da-4e24-4929-8efb-866ffcb1fe7e.eot": 2755,
	"./fonts/522972a6-5867-47ae-82fc-a7cf9bd5d4d4.eot": 2756,
	"./fonts/556d95c6-2352-4272-9422-83d53f66cfa3.ttf": 2757,
	"./fonts/5640036d-d549-4f16-b31e-87da78d9e832.eot": 2758,
	"./fonts/7802e576-2ffa-4f22-a409-534355fbea79.woff": 2759,
	"./fonts/7b415a05-784a-4a4c-8c94-67e9288312f5.woff": 2760,
	"./fonts/7d63ccf8-e0ae-4dee-ad4d-bbc798aa5803.woff2": 2761,
	"./fonts/800da3b0-675f-465f-892d-d76cecbdd5b1.woff2": 2762,
	"./fonts/8f4a1705-214a-4dd0-80b8-72252c37e688.ttf": 2763,
	"./fonts/922917a9-4ca8-4c0b-b1bb-417b6ff0210e.ttf": 2764,
	"./fonts/93ce67e5-64e3-4a99-99a3-545f20c5beec.woff2": 2765,
	"./fonts/96b3a113-3e18-46f9-b6e3-5bdee7288b20.woff": 2766,
	"./fonts/b2c1327f-ab3d-4230-93d7-eee8596e1498.woff": 2767,
	"./fonts/cad33bbd-bbf2-423b-98c5-51136c054e14.woff": 2768,
	"./fonts/cb0d1e8a-e111-4dbf-82c2-e948aba954c0.eot": 2769,
	"./fonts/da266c3a-a094-4adc-a81e-12f73609ba16.eot": 2770,
	"./fonts/f07c25ed-2d61-4e44-99ab-a0bc3ec67662.ttf": 2771,
	"./fonts/f9c5199e-a996-4c08-9042-1eb845bb7495.woff2": 2772,
	"./fonts/fdf10d5e-4ce0-45e5-a6c1-5eaff6cb1c11.ttf": 2773,
	"./fsi1.gif": 2774,
	"./fsi2.gif": 2775,
	"./fsi3.gif": 2776,
	"./fsi4.gif": 2777,
	"./fsiRealCase1-en.jpg": 1102,
	"./fsiRealCase1-mobile-en.jpg": 1103,
	"./fsiRealCase1-mobile-sc.jpg": 1104,
	"./fsiRealCase1-mobile.jpg": 1105,
	"./fsiRealCase1-sc.jpg": 1106,
	"./fsiRealCase1.jpg": 1107,
	"./fsiRealCase2-en-mobile.jpg": 1108,
	"./fsiRealCase2-en.jpg": 1109,
	"./fsiRealCase2-mobile-sc.jpg": 1110,
	"./fsiRealCase2-mobile.jpg": 1111,
	"./fsiRealCase2-sc.jpg": 1112,
	"./fsiRealCase2.jpg": 1113,
	"./general2024-1.gif": 2778,
	"./general2024-2.gif": 2779,
	"./general2024-3.gif": 2780,
	"./general2024-4.gif": 2781,
	"./general2024RealCase1-en-mobile.jpg": 1114,
	"./general2024RealCase1-en.jpg": 1115,
	"./general2024RealCase1-mobile-sc.jpg": 1116,
	"./general2024RealCase1-mobile.jpg": 1117,
	"./general2024RealCase1-sc.jpg": 1118,
	"./general2024RealCase1.jpg": 1119,
	"./globe.png": 304,
	"./hacker-using-laptop.gif": 2782,
	"./hacker1-en.png": 2783,
	"./hacker1.png": 2784,
	"./hacker2-en.png": 2785,
	"./hacker2.png": 2786,
	"./hacker3-en.png": 2787,
	"./hacker3.png": 2788,
	"./happy-emoji.png": 161,
	"./homelandingbg.png": 2789,
	"./icon-business.png": 305,
	"./icon-certificate.png": 306,
	"./icon-employee.png": 307,
	"./icon-training.png": 308,
	"./icon-vector1.png": 2790,
	"./icon-vector2.png": 2791,
	"./icon-vector3.png": 2792,
	"./icon-vector4.png": 2793,
	"./icon1.png": 2794,
	"./icon10.png": 2795,
	"./icon11.png": 2796,
	"./icon12.png": 2797,
	"./icon2.png": 2798,
	"./icon3.png": 2799,
	"./icon4.png": 2800,
	"./icon5.png": 2801,
	"./icon6.png": 2802,
	"./icon7.png": 2803,
	"./icon8.png": 2804,
	"./icon9.png": 2805,
	"./info-forgot-password-in.gif": 2806,
	"./info-journey-en.gif": 2807,
	"./info-journey.gif": 2808,
	"./info-new-mail.gif": 2809,
	"./info-password-security.gif": 2810,
	"./info-wifi.gif": 2811,
	"./it-gif1.gif": 2812,
	"./it-gif2.gif": 2813,
	"./it-gif3.gif": 2814,
	"./it-gif4.gif": 2815,
	"./it900-a031-en.jpg": 1120,
	"./it900-a031.jpg": 1121,
	"./it900-a32-1.jpg": 1122,
	"./it900-a32-2.jpg": 1123,
	"./it900-a32-3.jpg": 1124,
	"./it930-a033-1.jpg": 1125,
	"./it930-a033-2.jpg": 1126,
	"./it930-a033-3.jpg": 1127,
	"./it930-a033-4.jpg": 1128,
	"./it930-a033-5-en.jpg": 1129,
	"./it930-a033-5.jpg": 1130,
	"./lady-right-01.png": 2816,
	"./lady-right.jpg": 1131,
	"./lady-right.png": 2817,
	"./landingbg.png": 2818,
	"./logo.png": 2819,
	"./logo/consumer.png": 2820,
	"./logo/cpttm.png": 2821,
	"./logo/hkgcsmeaa.png": 2822,
	"./logo/logo.png": 2823,
	"./man-left-2.svg": 2824,
	"./man-right-2.png": 2825,
	"./man-right.jpg": 1132,
	"./man-right2.png": 2826,
	"./man.jpg": 1133,
	"./market-gif1.gif": 2827,
	"./market-gif2.gif": 2828,
	"./market-gif3.gif": 2829,
	"./market-gif4.gif": 2830,
	"./market-notpass.png": 750,
	"./market-quiz-info.png": 751,
	"./meeting.png": 2831,
	"./news-en.png": 2832,
	"./news-mobile-en.jpg": 1134,
	"./news-mobile-sc.jpg": 1135,
	"./news-mobile.jpg": 1136,
	"./news-sc.jpg": 1137,
	"./news.jpg": 1138,
	"./news.png": 2833,
	"./next-icon.svg": 752,
	"./ngo-a035-1.jpg": 1139,
	"./ngo-a035-2.jpg": 1140,
	"./ngo-a035-3.jpg": 1141,
	"./ngo-a035-4.jpg": 1142,
	"./ngo-a036-example-en.png": 2834,
	"./ngo-a036-example.jpg": 1143,
	"./ngo-gif1.gif": 2835,
	"./ngo-gif2.gif": 2836,
	"./ngo-gif3.gif": 2837,
	"./ngo-gif4.gif": 2838,
	"./notpass.png": 2839,
	"./office-risk1.png": 2840,
	"./office-risk2.png": 2841,
	"./office-risk3.png": 2842,
	"./office-risk4.png": 2843,
	"./office-risk5.png": 2844,
	"./org-brand1.png": 2845,
	"./ornament.png": 167,
	"./p-completed.svg": 2846,
	"./p-notstart.svg": 2847,
	"./p-onprogress-B.jpg": 1144,
	"./p-onprogress-E-commerce.png": 2848,
	"./p-onprogress-b.png": 2849,
	"./p-onprogress-cs.png": 2850,
	"./p-onprogress-fsi.png": 2851,
	"./p-onprogress-g.png": 2852,
	"./p-onprogress-general2024.png": 2853,
	"./p-onprogress-it.png": 2854,
	"./p-onprogress-ngo.png": 2855,
	"./p-onprogress-startup.png": 2856,
	"./p-onprogress-student.png": 2857,
	"./p-onprogress.svg": 2858,
	"./p9801.png": 404,
	"./pass.png": 753,
	"./phishing-indentify1.png": 2859,
	"./phishing-indentify2.png": 2860,
	"./phishing-indentify3.png": 2861,
	"./phishing-indentify4-en.png": 2862,
	"./phishing-indentify4.png": 2863,
	"./phishing-indentify5.png": 2864,
	"./phishing-indentify6.png": 2865,
	"./phishing1.png": 2866,
	"./phishing2.png": 2867,
	"./phishing3.png": 2868,
	"./phishing4.png": 2869,
	"./phishingicon1.png": 2870,
	"./phishingicon2.png": 2871,
	"./phishingicon3.png": 2872,
	"./phishingicon4.png": 2873,
	"./plus.png": 136,
	"./popover-red.png": 2874,
	"./popover.png": 2875,
	"./popup1.png": 2876,
	"./prev-icon.svg": 2877,
	"./pwc-logo-dark.png": 2878,
	"./pwc-logo-dark.svg": 2879,
	"./pwc-logo-white.png": 2880,
	"./pwc-logo-white.svg": 2881,
	"./pwc-logo.png": 2882,
	"./pwc-logo.svg": 2883,
	"./quiz-icon.png": 309,
	"./quiz-info.png": 2884,
	"./quizbg.png": 2885,
	"./ransomewareRealcase-en.png": 2886,
	"./ransomewareRealcase-mobile-en.png": 2887,
	"./ransomewareRealcase-mobile.png": 2888,
	"./ransomewareRealcase.png": 2889,
	"./ransomware.png": 2890,
	"./results1.png": 2891,
	"./results2.png": 2892,
	"./results3.png": 2893,
	"./results4.png": 2894,
	"./s3-001.png": 2895,
	"./s3-002.png": 2896,
	"./s3-003.png": 2897,
	"./s3-004.jpg": 1145,
	"./s3-005.jpg": 1146,
	"./s3-006.jpg": 1147,
	"./s3-007.jpg": 1148,
	"./s3-008.jpg": 1149,
	"./sample.png": 2898,
	"./secure-warning-bg.png": 2899,
	"./secure-warning1.png": 2900,
	"./secure-warning2.png": 2901,
	"./senior-sample1.png": 2902,
	"./senior-sample10.png": 2903,
	"./senior-sample2.png": 2904,
	"./senior-sample3-sc.png": 2905,
	"./senior-sample3.png": 2906,
	"./senior-sample4.png": 2907,
	"./senior-sample5.png": 2908,
	"./senior-sample6.png": 2909,
	"./senior-sample7.png": 2910,
	"./senior-sample8.png": 2911,
	"./senior-sample9.png": 2912,
	"./service.png": 754,
	"./small-icon1.png": 2913,
	"./small-icon10.png": 2914,
	"./small-icon2.png": 2915,
	"./small-icon3.png": 2916,
	"./small-icon4.png": 2917,
	"./small-icon5.png": 2918,
	"./small-icon6.png": 2919,
	"./small-icon7.png": 2920,
	"./small-icon8.png": 2921,
	"./small-icon9.png": 2922,
	"./sme/arrow_next.png": 755,
	"./sme/component/bubble_1_left.png": 2923,
	"./sme/component/bubble_1_right.png": 2924,
	"./sme/component/bubble_square_left.png": 2925,
	"./sme/component/bubble_square_right.png": 2926,
	"./sme/component/circle-active.png": 310,
	"./sme/component/circle-inactive.png": 311,
	"./sme/component/colon_icon.png": 312,
	"./sme/component/correct_icon.png": 313,
	"./sme/component/error_icon.png": 314,
	"./sme/component/example_top.png": 2927,
	"./sme/component/frame_bg.png": 2928,
	"./sme/component/icon/Activity.png": 315,
	"./sme/component/icon/ActivityInactive.png": 316,
	"./sme/component/icon/FolderPlus.png": 317,
	"./sme/component/icon/FolderPlusnactive.png": 318,
	"./sme/component/icon/Settings.png": 319,
	"./sme/component/icon/SettingsInactive.png": 320,
	"./sme/component/icon/Shield.png": 321,
	"./sme/component/icon/Shieldnactive.png": 322,
	"./sme/component/m_real-case-bg.png": 2929,
	"./sme/component/real-case-bg.png": 2930,
	"./sme/component/step-bg.png": 2931,
	"./sme/component/triangle-active.png": 323,
	"./sme/component/triangle-inactive.png": 324,
	"./sme/ics/attacker/card_bg_1.png": 127,
	"./sme/ics/attacker/card_bg_2.png": 128,
	"./sme/ics/attacker/card_bg_3.png": 129,
	"./sme/ics/attacker/card_bg_4.png": 130,
	"./sme/ics/attacker/card_bg_5.png": 131,
	"./sme/ics/carousel_card_bg.png": 2932,
	"./sme/ics/case_top_bg.png": 325,
	"./sme/ics/quiz_people.png": 326,
	"./sme/ics/target_bg.png": 327,
	"./sme/ics/title_icon.png": 328,
	"./sme/psa/quiz_people.png": 329,
	"./sme/psa/title_icon.png": 330,
	"./sme/quiz/downward_icon.png": 331,
	"./sme/quiz/mistakes_bg.png": 2933,
	"./sme/quiz/mistakes_icon.png": 332,
	"./sme/quiz/not_pass.png": 333,
	"./sme/quiz/pass.png": 334,
	"./sme/quiz/pass_upset.png": 335,
	"./sme/quiz/pen-tool.png": 336,
	"./sme/quiz/quiz.png": 337,
	"./sme/quiz/scoreRating_no_pass_bg.png": 338,
	"./sme/quiz/scoreRating_pass_bg.png": 339,
	"./sme/quiz/upset.png": 340,
	"./sme/sso/AiFace.gif": 341,
	"./sme/sso/FourPartIllustration.png": 132,
	"./sme/sso/icon1.png": 342,
	"./sme/sso/icon2.png": 343,
	"./sme/sso/icon3.png": 344,
	"./sme/sso/icon4.png": 345,
	"./sme/sso/title_icon.png": 346,
	"./sme/sso/topic2-quiz-bg.png": 347,
	"./sme/start_right.png": 2934,
	"./sme/tpv/FourPartIllustration.png": 348,
	"./sme/tpv/quiz-bg.png": 2935,
	"./sme/tpv/sace-bg.png": 349,
	"./sme/tpv/section1-bg.png": 350,
	"./sme/tpv/section3-bg.png": 2936,
	"./sme/tpv/title_icon.png": 351,
	"./sme/tpv/topic2-quiz-bg.png": 352,
	"./sme/uats/FourPartIllustration.png": 353,
	"./sme/uats/case_top_bg.png": 354,
	"./sme/uats/do_circle.png": 355,
	"./sme/uats/dont_circle.png": 356,
	"./sme/uats/quiz_bg.png": 357,
	"./sme/uats/robot.png": 358,
	"./sme/uats/title_icon.svg": 359,
	"./social-media-bg-g.png": 2937,
	"./social-media-bg.png": 2938,
	"./social-media.gif": 95,
	"./socialMedia.png": 2939,
	"./sponsor-logo/1.png": 2940,
	"./sponsor-logo/10.png": 2941,
	"./sponsor-logo/11.png": 2942,
	"./sponsor-logo/12.png": 2943,
	"./sponsor-logo/13.png": 2944,
	"./sponsor-logo/14.png": 2945,
	"./sponsor-logo/15.png": 2946,
	"./sponsor-logo/16.png": 2947,
	"./sponsor-logo/17.png": 2948,
	"./sponsor-logo/18.png": 2949,
	"./sponsor-logo/19.png": 2950,
	"./sponsor-logo/2.png": 2951,
	"./sponsor-logo/20.png": 2952,
	"./sponsor-logo/21.png": 2953,
	"./sponsor-logo/22.png": 2954,
	"./sponsor-logo/23.png": 2955,
	"./sponsor-logo/24.png": 2956,
	"./sponsor-logo/25.png": 2957,
	"./sponsor-logo/26.png": 2958,
	"./sponsor-logo/27.png": 2959,
	"./sponsor-logo/28.png": 2960,
	"./sponsor-logo/29.png": 2961,
	"./sponsor-logo/3.png": 2962,
	"./sponsor-logo/30.png": 2963,
	"./sponsor-logo/4.png": 2964,
	"./sponsor-logo/5.png": 2965,
	"./sponsor-logo/6.png": 2966,
	"./sponsor-logo/7.png": 2967,
	"./sponsor-logo/8.png": 2968,
	"./sponsor-logo/9.png": 2969,
	"./sponsor-logo/more1.png": 2970,
	"./startup1.gif": 2971,
	"./startup2.gif": 2972,
	"./startup3.gif": 2973,
	"./startup4.gif": 2974,
	"./startupRealCase1-en.jpg": 1150,
	"./startupRealCase1-mobile-en.jpg": 1151,
	"./startupRealCase1-mobile.jpg": 1152,
	"./startupRealCase1.jpg": 1153,
	"./startupRealCase2-en.jpg": 1154,
	"./startupRealCase2-mobile-en.jpg": 1155,
	"./startupRealCase2-mobile.jpg": 1156,
	"./startupRealCase2.jpg": 1157,
	"./step-c-1.png": 62,
	"./step-c-2.png": 63,
	"./step-c-3.png": 64,
	"./step-i-1.png": 2975,
	"./step-i-2.png": 2976,
	"./step-i-3.png": 2977,
	"./step-i-4.png": 2978,
	"./student.svg": 2979,
	"./student1.gif": 2980,
	"./student2.gif": 2981,
	"./student3.gif": 2982,
	"./student4.gif": 2983,
	"./studentRealCase1-en.png": 2984,
	"./studentRealCase1-mobile-en.png": 2985,
	"./studentRealCase1-mobile-sc.jpg": 1158,
	"./studentRealCase1-mobile.png": 2986,
	"./studentRealCase1-sc.jpg": 1159,
	"./studentRealCase1.png": 2987,
	"./studentRealCase2-en.png": 2988,
	"./studentRealCase2-mobile-en.png": 2989,
	"./studentRealCase2-mobile-sc.jpg": 1160,
	"./studentRealCase2-mobile.png": 2990,
	"./studentRealCase2-sc.jpg": 1161,
	"./studentRealCase2.png": 2991,
	"./support-org1.png": 2992,
	"./support-org2.png": 2993,
	"./support-org3.png": 2994,
	"./support-org4.png": 2995,
	"./test046.png": 2996,
	"./tip-arrow.png": 2997,
	"./tip1.png": 2998,
	"./tip2.png": 2999,
	"./tip3.png": 3000,
	"./tip4.png": 3001,
	"./tip5.png": 3002,
	"./tipbg.png": 3003,
	"./tips-person.png": 186,
	"./tips-person.svg": 3004,
	"./topic1.png": 3005,
	"./topic1200.png": 3006,
	"./topic1200bg.png": 3007,
	"./topic1400.png": 3008,
	"./topic1400bg.png": 3009,
	"./topic2.png": 3010,
	"./topic3.png": 3011,
	"./topic4.png": 3012,
	"./topic6.png": 3013,
	"./topic7.png": 3014,
	"./topic900.png": 3015,
	"./topic900bg.png": 3016,
	"./topic930.png": 3017,
	"./topic930bg.png": 3018,
	"./training-illustration.png": 3019,
	"./training-illustration10.png": 3020,
	"./training-illustration11.png": 3021,
	"./training-illustration12.png": 3022,
	"./training-illustration13.png": 3023,
	"./training-illustration2.png": 3024,
	"./training-illustration20.png": 3025,
	"./training-illustration21.png": 3026,
	"./training-illustration25.png": 3027,
	"./training-illustration26.png": 3028,
	"./training-illustration3.png": 3029,
	"./training-illustration4.svg": 3030,
	"./training-illustration5.svg": 3031,
	"./training-illustration6.svg": 3032,
	"./training-illustration7.png": 3033,
	"./training-illustration8.png": 3034,
	"./training-illustration9.png": 3035,
	"./transcrip.png": 162,
	"./unhappy-emoji.png": 163,
	"./useful-link-Icon.png": 3036,
	"./vector.png": 3037,
	"./vector137.png": 3038,
	"./video1-en.mp4": 3039,
	"./video1.mp4": 3040,
	"./video1more.mp4": 3041,
	"./video2.mp4": 3042,
	"./warning-alert-bg.png": 3043,
	"./warning-alert-bg2.png": 3044,
	"./welc1.gif": 3045,
	"./welc2.gif": 3046,
	"./welc3.gif": 3047,
	"./welc4.gif": 3048,
	"./welcome.gif": 3049,
	"./welcomeInfo.png": 3050,
	"./welcomeInfo2.png": 3051,
	"./welcomeInfo3.png": 3052,
	"./welcomeLandingbg-E-commerce.png": 3053,
	"./welcomeLandingbg-fsi.png": 3054,
	"./welcomeLandingbg-general2024.png": 3055,
	"./welcomeLandingbg-it.png": 3056,
	"./welcomeLandingbg-ngo.png": 3057,
	"./welcomeLandingbg-startup.png": 3058,
	"./welcomeLandingbg-student.png": 3059,
	"./welcomeLandingbg.png": 3060,
	"./whatsApp.png": 3061,
	"./whatsAppRealcase-en-mobile.png": 3062,
	"./whatsAppRealcase-en.png": 3063,
	"./whatsAppRealcase-mobile.png": 3064,
	"./whatsAppRealcase.png": 3065,
	"./working.png": 3066
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6;